
// @ts-nocheck


export const localeCodes =  [
  "en",
  "en_AU",
  "pt_BR",
  "zh_CN",
  "cs_CZ",
  "da_DK",
  "de_DE",
  "es_ES",
  "fr_FR",
  "it_IT",
  "ja_JP",
  "es_MX",
  "nl_NL",
  "no_NO",
  "pl_PL",
  "pt_PT",
  "sv_SE",
  "en_AE",
  "en_SG",
  "en_GB"
]

export const localeLoaders = {
  en: [],
  en_AU: [],
  pt_BR: [],
  zh_CN: [],
  cs_CZ: [],
  da_DK: [],
  de_DE: [],
  es_ES: [],
  fr_FR: [],
  it_IT: [],
  ja_JP: [],
  es_MX: [],
  nl_NL: [],
  no_NO: [],
  pl_PL: [],
  pt_PT: [],
  sv_SE: [],
  en_AE: [],
  en_SG: [],
  en_GB: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/5df9344a" /* webpackChunkName: "config_i18n_46config_46ts_5df9344a" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "Global",
      language: "en",
      _hreflang: "en",
      _sitemap: "en",
      files: []
    },
    {
      code: "en_AU",
      name: "Australia",
      language: "en-AU",
      _hreflang: "en-AU",
      _sitemap: "en-AU",
      files: []
    },
    {
      code: "pt_BR",
      name: "Brasil",
      language: "pt-BR",
      _hreflang: "pt-BR",
      _sitemap: "pt-BR",
      files: []
    },
    {
      code: "zh_CN",
      name: "中国",
      language: "zh-CN",
      _hreflang: "zh-CN",
      _sitemap: "zh-CN",
      files: []
    },
    {
      code: "cs_CZ",
      name: "Česká republika",
      language: "cs-CZ",
      _hreflang: "cs-CZ",
      _sitemap: "cs-CZ",
      files: []
    },
    {
      code: "da_DK",
      name: "Danmark",
      language: "da-DK",
      _hreflang: "da-DK",
      _sitemap: "da-DK",
      files: []
    },
    {
      code: "de_DE",
      name: "Deutschland",
      language: "de-DE",
      _hreflang: "de-DE",
      _sitemap: "de-DE",
      files: []
    },
    {
      code: "es_ES",
      name: "España",
      language: "es-ES",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: []
    },
    {
      code: "fr_FR",
      name: "France",
      language: "fr-FR",
      _hreflang: "fr-FR",
      _sitemap: "fr-FR",
      files: []
    },
    {
      code: "it_IT",
      name: "Italia",
      language: "it-IT",
      _hreflang: "it-IT",
      _sitemap: "it-IT",
      files: []
    },
    {
      code: "ja_JP",
      name: "日本",
      language: "ja-JP",
      _hreflang: "ja-JP",
      _sitemap: "ja-JP",
      files: []
    },
    {
      code: "es_MX",
      name: "México",
      language: "es-MX",
      _hreflang: "es-MX",
      _sitemap: "es-MX",
      files: []
    },
    {
      code: "nl_NL",
      name: "Nederland",
      language: "nl-NL",
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: []
    },
    {
      code: "no_NO",
      name: "Norge",
      language: "no-NO",
      _hreflang: "no-NO",
      _sitemap: "no-NO",
      files: []
    },
    {
      code: "pl_PL",
      name: "Polska",
      language: "pl-PL",
      _hreflang: "pl-PL",
      _sitemap: "pl-PL",
      files: []
    },
    {
      code: "pt_PT",
      name: "Portugal",
      language: "pt-PT",
      _hreflang: "pt-PT",
      _sitemap: "pt-PT",
      files: []
    },
    {
      code: "sv_SE",
      name: "Sverige",
      language: "sv-SE",
      _hreflang: "sv-SE",
      _sitemap: "sv-SE",
      files: []
    },
    {
      code: "en_AE",
      name: "United Arab Emirates",
      language: "en-AE",
      _hreflang: "en-AE",
      _sitemap: "en-AE",
      files: []
    },
    {
      code: "en_SG",
      name: "Singapore",
      language: "en-SG",
      _hreflang: "en-SG",
      _sitemap: "en-SG",
      files: []
    },
    {
      code: "en_GB",
      name: "United Kingdom",
      language: "en-GB",
      _hreflang: "en-GB",
      _sitemap: "en-GB",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://www.adyen.com",
  customRoutes: "config",
  pages: {
    "about/[slug]": {
      en: "/about/[slug]",
      "en-AU": "/about/[slug]",
      en_AU: "/about/[slug]",
      "pt-BR": "/sobre/[slug]",
      pt_BR: "/sobre/[slug]",
      "zh-CN": "/about/[slug]",
      zh_CN: "/about/[slug]",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/om-os/[slug]",
      da_DK: "/om-os/[slug]",
      "de-DE": "/uber/[slug]",
      de_DE: "/uber/[slug]",
      "es-ES": "/acerca-de/[slug]",
      es_ES: "/acerca-de/[slug]",
      "fr-FR": "/a-propos-de/[slug]",
      fr_FR: "/a-propos-de/[slug]",
      "it-IT": "/su-di-noi/[slug]",
      it_IT: "/su-di-noi/[slug]",
      "ja-JP": "/about/[slug]",
      ja_JP: "/about/[slug]",
      "es-MX": "/acerca-de/[slug]",
      es_MX: "/acerca-de/[slug]",
      "nl-NL": "/over-adyen/[slug]",
      nl_NL: "/over-adyen/[slug]",
      "no-NO": "/om/[slug]",
      no_NO: "/om/[slug]",
      "pl-PL": "/informacje/[slug]",
      pl_PL: "/informacje/[slug]",
      "pt-PT": "/sobre/[slug]",
      pt_PT: "/sobre/[slug]",
      "sv-SE": "/om/[slug]",
      sv_SE: "/om/[slug]",
      "en-AE": "/about/[slug]",
      en_AE: "/about/[slug]",
      "en-SG": "/about/[slug]",
      en_SG: "/about/[slug]",
      "en-GB": "/about/[slug]",
      en_GB: "/about/[slug]"
    },
    "about/index": {
      en: "/about",
      "en-AU": "/about",
      en_AU: "/about",
      "pt-BR": "/sobre",
      pt_BR: "/sobre",
      "zh-CN": "/about",
      zh_CN: "/about",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/om-os",
      da_DK: "/om-os",
      "de-DE": "/uber",
      de_DE: "/uber",
      "es-ES": "/acerca-de",
      es_ES: "/acerca-de",
      "fr-FR": "/a-propos-de",
      fr_FR: "/a-propos-de",
      "it-IT": "/su-di-noi",
      it_IT: "/su-di-noi",
      "ja-JP": "/about",
      ja_JP: "/about",
      "es-MX": "/acerca-de",
      es_MX: "/acerca-de",
      "nl-NL": "/over-adyen",
      nl_NL: "/over-adyen",
      "no-NO": "/om",
      no_NO: "/om",
      "pl-PL": "/informacje",
      pl_PL: "/informacje",
      "pt-PT": "/sobre",
      pt_PT: "/sobre",
      "sv-SE": "/om",
      sv_SE: "/om",
      "en-AE": "/about",
      en_AE: "/about",
      "en-SG": "/about",
      en_SG: "/about",
      "en-GB": "/about",
      en_GB: "/about"
    },
    "accept-payments/index": {
      en: "/accept-payments",
      "en-AU": "/accept-payments",
      en_AU: "/accept-payments",
      "pt-BR": "/aceite-pagamentos",
      pt_BR: "/aceite-pagamentos",
      "zh-CN": "/accept-payments",
      zh_CN: "/accept-payments",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/accepter-betalinger",
      da_DK: "/accepter-betalinger",
      "de-DE": "/zahlungen-empfangen",
      de_DE: "/zahlungen-empfangen",
      "es-ES": "/plataforma-de-pagos",
      es_ES: "/plataforma-de-pagos",
      "fr-FR": "/accepter-les-paiements",
      fr_FR: "/accepter-les-paiements",
      "it-IT": "/accettazione-pagamenti",
      it_IT: "/accettazione-pagamenti",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/acepta-pagos",
      es_MX: "/acepta-pagos",
      "nl-NL": "/accepteer-betalingen",
      nl_NL: "/accepteer-betalingen",
      "no-NO": "/aksepter-betalinger",
      no_NO: "/aksepter-betalinger",
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": "/ta-emot-betalningar",
      sv_SE: "/ta-emot-betalningar",
      "en-AE": "/accept-payments",
      en_AE: "/accept-payments",
      "en-SG": "/accept-payments",
      en_SG: "/accept-payments",
      "en-GB": "/accept-payments",
      en_GB: "/accept-payments"
    },
    "accounts/index": {
      en: "/accounts",
      "en-AU": "/accounts",
      en_AU: "/accounts",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/accounts",
      da_DK: "/accounts",
      "de-DE": "/accounts",
      de_DE: "/accounts",
      "es-ES": "/cuentas",
      es_ES: "/cuentas",
      "fr-FR": "/accounts",
      fr_FR: "/accounts",
      "it-IT": "/accounts",
      it_IT: "/accounts",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/accounts",
      nl_NL: "/accounts",
      "no-NO": "/kontoer",
      no_NO: "/kontoer",
      "pl-PL": "/accounts",
      pl_PL: "/accounts",
      "pt-PT": "/contas",
      pt_PT: "/contas",
      "sv-SE": "/konton",
      sv_SE: "/konton",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/accounts",
      en_SG: "/accounts",
      "en-GB": "/accounts",
      en_GB: "/accounts"
    },
    "capital/index": {
      en: "/capital",
      "en-AU": "/capital",
      en_AU: "/capital",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/capital",
      da_DK: "/capital",
      "de-DE": "/capital",
      de_DE: "/capital",
      "es-ES": "/capital",
      es_ES: "/capital",
      "fr-FR": "/capital",
      fr_FR: "/capital",
      "it-IT": "/capital",
      it_IT: "/capital",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/capital",
      nl_NL: "/capital",
      "no-NO": "/capital",
      no_NO: "/capital",
      "pl-PL": "/capital",
      pl_PL: "/capital",
      "pt-PT": "/capital",
      pt_PT: "/capital",
      "sv-SE": "/kapital",
      sv_SE: "/kapital",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/capital",
      en_SG: "/capital",
      "en-GB": "/capital",
      en_GB: "/capital"
    },
    "contact/[slug]": {
      en: "/contact/[slug]",
      "en-AU": "/contact/[slug]",
      en_AU: "/contact/[slug]",
      "pt-BR": "/contato/[slug]",
      pt_BR: "/contato/[slug]",
      "zh-CN": "/contact/[slug]",
      zh_CN: "/contact/[slug]",
      "cs-CZ": "/contact/[slug]",
      cs_CZ: "/contact/[slug]",
      "da-DK": "/kontakt/[slug]",
      da_DK: "/kontakt/[slug]",
      "de-DE": "/kontakt/[slug]",
      de_DE: "/kontakt/[slug]",
      "es-ES": "/contacto/[slug]",
      es_ES: "/contacto/[slug]",
      "fr-FR": "/contact/[slug]",
      fr_FR: "/contact/[slug]",
      "it-IT": "/contact/[slug]",
      it_IT: "/contact/[slug]",
      "ja-JP": "/contact/[slug]",
      ja_JP: "/contact/[slug]",
      "es-MX": "/contact/[slug]",
      es_MX: "/contact/[slug]",
      "nl-NL": "/contact/[slug]",
      nl_NL: "/contact/[slug]",
      "no-NO": "/kontakt/[slug]",
      no_NO: "/kontakt/[slug]",
      "pl-PL": "/kontakt/[slug]",
      pl_PL: "/kontakt/[slug]",
      "pt-PT": "/contato/[slug]",
      pt_PT: "/contato/[slug]",
      "sv-SE": "/kontakt/[slug]",
      sv_SE: "/kontakt/[slug]",
      "en-AE": "/contact/[slug]",
      en_AE: "/contact/[slug]",
      "en-SG": "/contact/[slug]",
      en_SG: "/contact/[slug]",
      "en-GB": "/contact/[slug]",
      en_GB: "/contact/[slug]"
    },
    "contact/index": {
      en: "/contact",
      "en-AU": "/contact",
      en_AU: "/contact",
      "pt-BR": "/contato",
      pt_BR: "/contato",
      "zh-CN": "/contact",
      zh_CN: "/contact",
      "cs-CZ": "/contact",
      cs_CZ: "/contact",
      "da-DK": "/kontakt",
      da_DK: "/kontakt",
      "de-DE": "/kontakt",
      de_DE: "/kontakt",
      "es-ES": "/contacto",
      es_ES: "/contacto",
      "fr-FR": "/contact",
      fr_FR: "/contact",
      "it-IT": "/contact",
      it_IT: "/contact",
      "ja-JP": "/contact",
      ja_JP: "/contact",
      "es-MX": "/contact",
      es_MX: "/contact",
      "nl-NL": "/contact",
      nl_NL: "/contact",
      "no-NO": "/kontakt",
      no_NO: "/kontakt",
      "pl-PL": "/kontakt",
      pl_PL: "/kontakt",
      "pt-PT": "/contato",
      pt_PT: "/contato",
      "sv-SE": "/kontakt",
      sv_SE: "/kontakt",
      "en-AE": "/contact",
      en_AE: "/contact",
      "en-SG": "/contact",
      en_SG: "/contact",
      "en-GB": "/contact",
      en_GB: "/contact"
    },
    "customer-area/index": {
      en: "/customer-area",
      "en-AU": "/customer-area",
      en_AU: "/customer-area",
      "pt-BR": "/relatorios",
      pt_BR: "/relatorios",
      "zh-CN": "/customer-area",
      zh_CN: "/customer-area",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/rapportering",
      da_DK: "/rapportering",
      "de-DE": "/berichterstattung",
      de_DE: "/berichterstattung",
      "es-ES": "/customer-area",
      es_ES: "/customer-area",
      "fr-FR": "/customer-area",
      fr_FR: "/customer-area",
      "it-IT": "/report",
      it_IT: "/report",
      "ja-JP": "/customer-area",
      ja_JP: "/customer-area",
      "es-MX": "/customer-area",
      es_MX: "/customer-area",
      "nl-NL": "/rapportage",
      nl_NL: "/rapportage",
      "no-NO": "/rapportering",
      no_NO: "/rapportering",
      "pl-PL": "/raporty",
      pl_PL: "/raporty",
      "pt-PT": "/customer-area",
      pt_PT: "/customer-area",
      "sv-SE": "/rapportering",
      sv_SE: "/rapportering",
      "en-AE": "/customer-area",
      en_AE: "/customer-area",
      "en-SG": "/customer-area",
      en_SG: "/customer-area",
      "en-GB": "/customer-area",
      en_GB: "/customer-area"
    },
    "customers/index": {
      en: "/customers",
      "en-AU": "/customers",
      en_AU: "/customers",
      "pt-BR": "/clientes",
      pt_BR: "/clientes",
      "zh-CN": "/customers",
      zh_CN: "/customers",
      "cs-CZ": "/customers",
      cs_CZ: "/customers",
      "da-DK": "/kunder",
      da_DK: "/kunder",
      "de-DE": "/kunden",
      de_DE: "/kunden",
      "es-ES": "/clientes",
      es_ES: "/clientes",
      "fr-FR": "/clients",
      fr_FR: "/clients",
      "it-IT": "/clienti",
      it_IT: "/clienti",
      "ja-JP": "/customers",
      ja_JP: "/customers",
      "es-MX": "/customers",
      es_MX: "/customers",
      "nl-NL": "/klanten",
      nl_NL: "/klanten",
      "no-NO": "/kunder",
      no_NO: "/kunder",
      "pl-PL": "/klienci",
      pl_PL: "/klienci",
      "pt-PT": "/clientes",
      pt_PT: "/clientes",
      "sv-SE": "/referenser",
      sv_SE: "/referenser",
      "en-AE": "/customers",
      en_AE: "/customers",
      "en-SG": "/customers",
      en_SG: "/customers",
      "en-GB": "/customers",
      en_GB: "/customers"
    },
    "devices/[slug]": {
      en: "/devices/[slug]",
      "en-AU": "/devices/[slug]",
      en_AU: "/devices/[slug]",
      "pt-BR": "/dispositivos/[slug]",
      pt_BR: "/dispositivos/[slug]",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/enheder/[slug]",
      da_DK: "/enheder/[slug]",
      "de-DE": "/terminals/[slug]",
      de_DE: "/terminals/[slug]",
      "es-ES": "/dispositivos-tpv/[slug]",
      es_ES: "/dispositivos-tpv/[slug]",
      "fr-FR": "/terminaux/[slug]",
      fr_FR: "/terminaux/[slug]",
      "it-IT": "/devices/[slug]",
      it_IT: "/devices/[slug]",
      "ja-JP": "/devices/[slug]",
      ja_JP: "/devices/[slug]",
      "es-MX": "/dispositivos/[slug]",
      es_MX: "/dispositivos/[slug]",
      "nl-NL": "/pinapparaten/[slug]",
      nl_NL: "/pinapparaten/[slug]",
      "no-NO": "/enheter/[slug]",
      no_NO: "/enheter/[slug]",
      "pl-PL": "/terminale/[slug]",
      pl_PL: "/terminale/[slug]",
      "pt-PT": "/dispositivos-pos/[slug]",
      pt_PT: "/dispositivos-pos/[slug]",
      "sv-SE": "/enheter/[slug]",
      sv_SE: "/enheter/[slug]",
      "en-AE": "/devices/[slug]",
      en_AE: "/devices/[slug]",
      "en-SG": "/devices/[slug]",
      en_SG: "/devices/[slug]",
      "en-GB": "/devices/[slug]",
      en_GB: "/devices/[slug]"
    },
    "devices/comparison/index": {
      en: "/devices/comparison",
      "en-AU": "/devices/comparison",
      en_AU: "/devices/comparison",
      "pt-BR": "/dispositivos/comparacao",
      pt_BR: "/dispositivos/comparacao",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/enheder/sammenlign",
      da_DK: "/enheder/sammenlign",
      "de-DE": "/terminals/vergleichen",
      de_DE: "/terminals/vergleichen",
      "es-ES": "/dispositivos-tpv/comparacion",
      es_ES: "/dispositivos-tpv/comparacion",
      "fr-FR": "/terminaux/comparaison",
      fr_FR: "/terminaux/comparaison",
      "it-IT": "/devices/confronta",
      it_IT: "/devices/confronta",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/dispositivos/comparacion",
      es_MX: "/dispositivos/comparacion",
      "nl-NL": "/pinapparaten/vergelijk",
      nl_NL: "/pinapparaten/vergelijk",
      "no-NO": "/enheter/sammenlign",
      no_NO: "/enheter/sammenlign",
      "pl-PL": "/terminale/porownaj",
      pl_PL: "/terminale/porownaj",
      "pt-PT": "/dispositivos-pos/comparacao",
      pt_PT: "/dispositivos-pos/comparacao",
      "sv-SE": "/enheter/jamfor",
      sv_SE: "/enheter/jamfor",
      "en-AE": "/devices/comparison",
      en_AE: "/devices/comparison",
      "en-SG": "/devices/comparison",
      en_SG: "/devices/comparison",
      "en-GB": "/devices/comparison",
      en_GB: "/devices/comparison"
    },
    "devices/index": {
      en: "/devices",
      "en-AU": "/devices",
      en_AU: "/devices",
      "pt-BR": "/dispositivos",
      pt_BR: "/dispositivos",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/enheder",
      da_DK: "/enheder",
      "de-DE": "/terminals",
      de_DE: "/terminals",
      "es-ES": "/dispositivos-tpv",
      es_ES: "/dispositivos-tpv",
      "fr-FR": "/terminaux",
      fr_FR: "/terminaux",
      "it-IT": "/devices",
      it_IT: "/devices",
      "ja-JP": "/devices",
      ja_JP: "/devices",
      "es-MX": "/dispositivos",
      es_MX: "/dispositivos",
      "nl-NL": "/pinapparaten",
      nl_NL: "/pinapparaten",
      "no-NO": "/enheter",
      no_NO: "/enheter",
      "pl-PL": "/terminale",
      pl_PL: "/terminale",
      "pt-PT": "/dispositivos-pos",
      pt_PT: "/dispositivos-pos",
      "sv-SE": "/enheter",
      sv_SE: "/enheter",
      "en-AE": "/devices",
      en_AE: "/devices",
      "en-SG": "/devices",
      en_SG: "/devices",
      "en-GB": "/devices",
      en_GB: "/devices"
    },
    "events/[slug]": {
      en: "/events/[slug]",
      "en-AU": "/events/[slug]",
      en_AU: "/events/[slug]",
      "pt-BR": "/events/[slug]",
      pt_BR: "/events/[slug]",
      "zh-CN": "/events/[slug]",
      zh_CN: "/events/[slug]",
      "cs-CZ": "/events/[slug]",
      cs_CZ: "/events/[slug]",
      "da-DK": "/events/[slug]",
      da_DK: "/events/[slug]",
      "de-DE": "/events/[slug]",
      de_DE: "/events/[slug]",
      "es-ES": "/events/[slug]",
      es_ES: "/events/[slug]",
      "fr-FR": "/events/[slug]",
      fr_FR: "/events/[slug]",
      "it-IT": "/events/[slug]",
      it_IT: "/events/[slug]",
      "ja-JP": "/events/[slug]",
      ja_JP: "/events/[slug]",
      "es-MX": "/events/[slug]",
      es_MX: "/events/[slug]",
      "nl-NL": "/events/[slug]",
      nl_NL: "/events/[slug]",
      "no-NO": "/events/[slug]",
      no_NO: "/events/[slug]",
      "pl-PL": "/events/[slug]",
      pl_PL: "/events/[slug]",
      "pt-PT": "/events/[slug]",
      pt_PT: "/events/[slug]",
      "sv-SE": "/events/[slug]",
      sv_SE: "/events/[slug]",
      "en-AE": "/events/[slug]",
      en_AE: "/events/[slug]",
      "en-SG": false,
      en_SG: false,
      "en-GB": "/events/[slug]",
      en_GB: "/events/[slug]"
    },
    "events/index": {
      en: "/events",
      "en-AU": "/events",
      en_AU: "/events",
      "pt-BR": "/events",
      pt_BR: "/events",
      "zh-CN": "/events",
      zh_CN: "/events",
      "cs-CZ": "/events",
      cs_CZ: "/events",
      "da-DK": "/events",
      da_DK: "/events",
      "de-DE": "/events",
      de_DE: "/events",
      "es-ES": "/events",
      es_ES: "/events",
      "fr-FR": "/events",
      fr_FR: "/events",
      "it-IT": "/events",
      it_IT: "/events",
      "ja-JP": "/events",
      ja_JP: "/events",
      "es-MX": "/events",
      es_MX: "/events",
      "nl-NL": "/events",
      nl_NL: "/events",
      "no-NO": "/events",
      no_NO: "/events",
      "pl-PL": "/events",
      pl_PL: "/events",
      "pt-PT": "/events",
      pt_PT: "/events",
      "sv-SE": "/events",
      sv_SE: "/events",
      "en-AE": "/events",
      en_AE: "/events",
      "en-SG": false,
      en_SG: false,
      "en-GB": "/events",
      en_GB: "/events"
    },
    "giving/index": {
      en: "/giving",
      "en-AU": "/giving",
      en_AU: "/giving",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/giving",
      da_DK: "/giving",
      "de-DE": "/giving",
      de_DE: "/giving",
      "es-ES": "/giving",
      es_ES: "/giving",
      "fr-FR": "/giving",
      fr_FR: "/giving",
      "it-IT": "/giving",
      it_IT: "/giving",
      "ja-JP": "/giving",
      ja_JP: "/giving",
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/giving",
      nl_NL: "/giving",
      "no-NO": "/giving",
      no_NO: "/giving",
      "pl-PL": "/giving",
      pl_PL: "/giving",
      "pt-PT": "/giving",
      pt_PT: "/giving",
      "sv-SE": "/giving",
      sv_SE: "/giving",
      "en-AE": "/giving",
      en_AE: "/giving",
      "en-SG": "/giving",
      en_SG: "/giving",
      "en-GB": "/giving",
      en_GB: "/giving"
    },
    "giving/nonprofit/[slug]": {
      en: "/giving/nonprofit/[slug]",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "giving/nonprofit/index": {
      en: "/giving/nonprofit",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "global-payment-processing/index": {
      en: "/global-payment-processing",
      "en-AU": "/global-payment-processing",
      en_AU: "/global-payment-processing",
      "pt-BR": "/processamento-global-pagamentos",
      pt_BR: "/processamento-global-pagamentos",
      "zh-CN": "/global-payment-processing",
      zh_CN: "/global-payment-processing",
      "cs-CZ": "/platebni-platforma",
      cs_CZ: "/platebni-platforma",
      "da-DK": "/global-betalingsbehandling",
      da_DK: "/global-betalingsbehandling",
      "de-DE": "/globale-zahlungsabwicklung",
      de_DE: "/globale-zahlungsabwicklung",
      "es-ES": "/adquirencia-medios-de-pago",
      es_ES: "/adquirencia-medios-de-pago",
      "fr-FR": "/traitement-mondial-des-paiements",
      fr_FR: "/traitement-mondial-des-paiements",
      "it-IT": "/acquiring-globale",
      it_IT: "/acquiring-globale",
      "ja-JP": "/global-payment-processing",
      ja_JP: "/global-payment-processing",
      "es-MX": "/adquirencia-medios-de-pago",
      es_MX: "/adquirencia-medios-de-pago",
      "nl-NL": "/wereldwijde-betaalverwerking",
      nl_NL: "/wereldwijde-betaalverwerking",
      "no-NO": "/global-betalingsprosessering",
      no_NO: "/global-betalingsprosessering",
      "pl-PL": "/globalna-bramka-platnicza",
      pl_PL: "/globalna-bramka-platnicza",
      "pt-PT": "/processamento-global-pagamentos",
      pt_PT: "/processamento-global-pagamentos",
      "sv-SE": "/kortinlosen",
      sv_SE: "/kortinlosen",
      "en-AE": "/global-payment-processing",
      en_AE: "/global-payment-processing",
      "en-SG": "/global-payment-processing",
      en_SG: "/global-payment-processing",
      "en-GB": "/global-payment-processing",
      en_GB: "/global-payment-processing"
    },
    "impact/index": {
      en: "/impact",
      "en-AU": "/impact",
      en_AU: "/impact",
      "pt-BR": "/impact",
      pt_BR: "/impact",
      "zh-CN": "/impact",
      zh_CN: "/impact",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/impact",
      da_DK: "/impact",
      "de-DE": "/impact",
      de_DE: "/impact",
      "es-ES": "/impact",
      es_ES: "/impact",
      "fr-FR": "/impact",
      fr_FR: "/impact",
      "it-IT": "/impact",
      it_IT: "/impact",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/impact",
      es_MX: "/impact",
      "nl-NL": "/impact",
      nl_NL: "/impact",
      "no-NO": "/impact",
      no_NO: "/impact",
      "pl-PL": "/impact",
      pl_PL: "/impact",
      "pt-PT": "/impact",
      pt_PT: "/impact",
      "sv-SE": "/impact",
      sv_SE: "/impact",
      "en-AE": "/impact",
      en_AE: "/impact",
      "en-SG": "/impact",
      en_SG: "/impact",
      "en-GB": "/impact",
      en_GB: "/impact"
    },
    "impact/people/index": {
      en: "/impact/people",
      "en-AU": "/impact/people",
      en_AU: "/impact/people",
      "pt-BR": "/impact/people",
      pt_BR: "/impact/people",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/impact/people",
      da_DK: "/impact/people",
      "de-DE": "/impact/people",
      de_DE: "/impact/people",
      "es-ES": "/impact/people",
      es_ES: "/impact/people",
      "fr-FR": "/impact/people",
      fr_FR: "/impact/people",
      "it-IT": "/impact/people",
      it_IT: "/impact/people",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/impact/people",
      es_MX: "/impact/people",
      "nl-NL": "/impact/people",
      nl_NL: "/impact/people",
      "no-NO": "/impact/people",
      no_NO: "/impact/people",
      "pl-PL": "/impact/people",
      pl_PL: "/impact/people",
      "pt-PT": "/impact/people",
      pt_PT: "/impact/people",
      "sv-SE": "/impact/people",
      sv_SE: "/impact/people",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/impact/people",
      en_SG: "/impact/people",
      "en-GB": "/impact/people",
      en_GB: "/impact/people"
    },
    "impact/planet/index": {
      en: "/impact/planet",
      "en-AU": "/impact/planet",
      en_AU: "/impact/planet",
      "pt-BR": "/impact/planet",
      pt_BR: "/impact/planet",
      "zh-CN": "/impact/planet",
      zh_CN: "/impact/planet",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/impact/planet",
      da_DK: "/impact/planet",
      "de-DE": "/impact/planet",
      de_DE: "/impact/planet",
      "es-ES": "/impact/planet",
      es_ES: "/impact/planet",
      "fr-FR": "/impact/planet",
      fr_FR: "/impact/planet",
      "it-IT": "/impact/planet",
      it_IT: "/impact/planet",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/impact/planet",
      es_MX: "/impact/planet",
      "nl-NL": "/impact/planet",
      nl_NL: "/impact/planet",
      "no-NO": "/impact/planet",
      no_NO: "/impact/planet",
      "pl-PL": "/impact/planet",
      pl_PL: "/impact/planet",
      "pt-PT": "/impact/planet",
      pt_PT: "/impact/planet",
      "sv-SE": "/impact/planet",
      sv_SE: "/impact/planet",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/impact/planet",
      en_SG: "/impact/planet",
      "en-GB": "/impact/planet",
      en_GB: "/impact/planet"
    },
    "index-reports/[industry]/[slug]": {
      en: "/index-reports/[industry]/[slug]",
      "en-AU": "/index-reports/[industry]/[slug]",
      en_AU: "/index-reports/[industry]/[slug]",
      "pt-BR": "/index-reports/[industry]/[slug]",
      pt_BR: "/index-reports/[industry]/[slug]",
      "zh-CN": "/index-reports/[industry]/[slug]",
      zh_CN: "/index-reports/[industry]/[slug]",
      "cs-CZ": "/index-reports/[industry]/[slug]",
      cs_CZ: "/index-reports/[industry]/[slug]",
      "da-DK": "/index-reports/[industry]/[slug]",
      da_DK: "/index-reports/[industry]/[slug]",
      "de-DE": "/index-reports/[industry]/[slug]",
      de_DE: "/index-reports/[industry]/[slug]",
      "es-ES": "/index-reports/[industry]/[slug]",
      es_ES: "/index-reports/[industry]/[slug]",
      "fr-FR": "/index-reports/[industry]/[slug]",
      fr_FR: "/index-reports/[industry]/[slug]",
      "it-IT": "/index-reports/[industry]/[slug]",
      it_IT: "/index-reports/[industry]/[slug]",
      "ja-JP": "/index-reports/[industry]/[slug]",
      ja_JP: "/index-reports/[industry]/[slug]",
      "es-MX": "/index-reports/[industry]/[slug]",
      es_MX: "/index-reports/[industry]/[slug]",
      "nl-NL": "/index-reports/[industry]/[slug]",
      nl_NL: "/index-reports/[industry]/[slug]",
      "no-NO": "/index-reports/[industry]/[slug]",
      no_NO: "/index-reports/[industry]/[slug]",
      "pl-PL": "/index-reports/[industry]/[slug]",
      pl_PL: "/index-reports/[industry]/[slug]",
      "pt-PT": "/index-reports/[industry]/[slug]",
      pt_PT: "/index-reports/[industry]/[slug]",
      "sv-SE": "/index-reports/[industry]/[slug]",
      sv_SE: "/index-reports/[industry]/[slug]",
      "en-AE": "/index-reports/[industry]/[slug]",
      en_AE: "/index-reports/[industry]/[slug]",
      "en-SG": "/index-reports/[industry]/[slug]",
      en_SG: "/index-reports/[industry]/[slug]",
      "en-GB": "/index-reports/[industry]/[slug]",
      en_GB: "/index-reports/[industry]/[slug]"
    },
    "index-reports/[slug]": {
      en: "/index-reports/[slug]",
      "en-AU": "/index-reports/[slug]",
      en_AU: "/index-reports/[slug]",
      "pt-BR": "/index-reports/[slug]",
      pt_BR: "/index-reports/[slug]",
      "zh-CN": "/index-reports/[slug]",
      zh_CN: "/index-reports/[slug]",
      "cs-CZ": "/index-reports/[slug]",
      cs_CZ: "/index-reports/[slug]",
      "da-DK": "/index-reports/[slug]",
      da_DK: "/index-reports/[slug]",
      "de-DE": "/index-reports/[slug]",
      de_DE: "/index-reports/[slug]",
      "es-ES": "/index-reports/[slug]",
      es_ES: "/index-reports/[slug]",
      "fr-FR": "/index-reports/[slug]",
      fr_FR: "/index-reports/[slug]",
      "it-IT": "/index-reports/[slug]",
      it_IT: "/index-reports/[slug]",
      "ja-JP": "/index-reports/[slug]",
      ja_JP: "/index-reports/[slug]",
      "es-MX": "/index-reports/[slug]",
      es_MX: "/index-reports/[slug]",
      "nl-NL": "/index-reports/[slug]",
      nl_NL: "/index-reports/[slug]",
      "no-NO": "/index-reports/[slug]",
      no_NO: "/index-reports/[slug]",
      "pl-PL": "/index-reports/[slug]",
      pl_PL: "/index-reports/[slug]",
      "pt-PT": "/index-reports/[slug]",
      pt_PT: "/index-reports/[slug]",
      "sv-SE": "/index-reports/[slug]",
      sv_SE: "/index-reports/[slug]",
      "en-AE": "/index-reports/[slug]",
      en_AE: "/index-reports/[slug]",
      "en-SG": "/index-reports/[slug]",
      en_SG: "/index-reports/[slug]",
      "en-GB": "/index-reports/[slug]",
      en_GB: "/index-reports/[slug]"
    },
    "index-reports/index": {
      en: "/index-reports",
      "en-AU": "/index-reports",
      en_AU: "/index-reports",
      "pt-BR": "/index-reports",
      pt_BR: "/index-reports",
      "zh-CN": "/index-reports",
      zh_CN: "/index-reports",
      "cs-CZ": "/index-reports",
      cs_CZ: "/index-reports",
      "da-DK": "/index-reports",
      da_DK: "/index-reports",
      "de-DE": "/index-reports",
      de_DE: "/index-reports",
      "es-ES": "/index-reports",
      es_ES: "/index-reports",
      "fr-FR": "/index-reports",
      fr_FR: "/index-reports",
      "it-IT": "/index-reports",
      it_IT: "/index-reports",
      "ja-JP": "/index-reports",
      ja_JP: "/index-reports",
      "es-MX": "/index-reports",
      es_MX: "/index-reports",
      "nl-NL": "/index-reports",
      nl_NL: "/index-reports",
      "no-NO": "/index-reports",
      no_NO: "/index-reports",
      "pl-PL": "/index-reports",
      pl_PL: "/index-reports",
      "pt-PT": "/index-reports",
      pt_PT: "/index-reports",
      "sv-SE": "/index-reports",
      sv_SE: "/index-reports",
      "en-AE": "/index-reports",
      en_AE: "/index-reports",
      "en-SG": "/index-reports",
      en_SG: "/index-reports",
      "en-GB": "/index-reports",
      en_GB: "/index-reports"
    },
    "index-reports/previous/index": {
      en: "/index-reports/previous",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    index: {
      en: "/",
      "en-AU": "/",
      en_AU: "/",
      "pt-BR": "/",
      pt_BR: "/",
      "zh-CN": "/",
      zh_CN: "/",
      "cs-CZ": "/",
      cs_CZ: "/",
      "da-DK": "/",
      da_DK: "/",
      "de-DE": "/",
      de_DE: "/",
      "es-ES": "/",
      es_ES: "/",
      "fr-FR": "/",
      fr_FR: "/",
      "it-IT": "/",
      it_IT: "/",
      "ja-JP": "/",
      ja_JP: "/",
      "es-MX": "/",
      es_MX: "/",
      "nl-NL": "/",
      nl_NL: "/",
      "no-NO": "/",
      no_NO: "/",
      "pl-PL": "/",
      pl_PL: "/",
      "pt-PT": "/",
      pt_PT: "/",
      "sv-SE": "/",
      sv_SE: "/",
      "en-AE": "/",
      en_AE: "/",
      "en-SG": "/",
      en_SG: "/",
      "en-GB": "/",
      en_GB: "/"
    },
    "industries/digital/index": {
      en: "/industries/digital",
      "en-AU": "/industries/digital",
      en_AU: "/industries/digital",
      "pt-BR": "/setores/digital",
      pt_BR: "/setores/digital",
      "zh-CN": "/industries/digital",
      zh_CN: "/industries/digital",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/industrier/digital",
      da_DK: "/industrier/digital",
      "de-DE": "/branchen/digital",
      de_DE: "/branchen/digital",
      "es-ES": "/sectores/digital",
      es_ES: "/sectores/digital",
      "fr-FR": "/secteurs/digital",
      fr_FR: "/secteurs/digital",
      "it-IT": "/settori/digital",
      it_IT: "/settori/digital",
      "ja-JP": "/industries/digital",
      ja_JP: "/industries/digital",
      "es-MX": "/industrias/digital",
      es_MX: "/industrias/digital",
      "nl-NL": "/industrieen/digital",
      nl_NL: "/industrieen/digital",
      "no-NO": "/bransjer/digital",
      no_NO: "/bransjer/digital",
      "pl-PL": "/branze/digital",
      pl_PL: "/branze/digital",
      "pt-PT": "/setores/digital",
      pt_PT: "/setores/digital",
      "sv-SE": "/branscher/digital",
      sv_SE: "/branscher/digital",
      "en-AE": "/industries/digital",
      en_AE: "/industries/digital",
      "en-SG": "/industries/digital",
      en_SG: "/industries/digital",
      "en-GB": "/industries/digital",
      en_GB: "/industries/digital"
    },
    "industries/digital-businesses/index": {
      en: "/industries/digital-businesses",
      "en-AU": "/industries/digital",
      en_AU: "/industries/digital",
      "pt-BR": "/setores/pagamentos-digital",
      pt_BR: "/setores/pagamentos-digital",
      "zh-CN": "/industries/digital",
      zh_CN: "/industries/digital",
      "cs-CZ": "/industries/digital",
      cs_CZ: "/industries/digital",
      "da-DK": "/industrier/digitale-betalinger",
      da_DK: "/industrier/digitale-betalinger",
      "de-DE": "/branchen/digitale-zahlungen",
      de_DE: "/branchen/digitale-zahlungen",
      "es-ES": "/sectores/pagos-digitales",
      es_ES: "/sectores/pagos-digitales",
      "fr-FR": "/secteurs/paiements-digitaux",
      fr_FR: "/secteurs/paiements-digitaux",
      "it-IT": "/settori/pagamenti-digital",
      it_IT: "/settori/pagamenti-digital",
      "ja-JP": "/industries/digital",
      ja_JP: "/industries/digital",
      "es-MX": "/industrias/pagos-digitales",
      es_MX: "/industrias/pagos-digitales",
      "nl-NL": "/industrieen/digitale-betalingen",
      nl_NL: "/industrieen/digitale-betalingen",
      "no-NO": "/bransjer/digitale-betalinger",
      no_NO: "/bransjer/digitale-betalinger",
      "pl-PL": "/branze/platnosci-dla-digital",
      pl_PL: "/branze/platnosci-dla-digital",
      "pt-PT": "/setores/digital",
      pt_PT: "/setores/digital",
      "sv-SE": "/branscher/digitala-betalningar",
      sv_SE: "/branscher/digitala-betalningar",
      "en-AE": "/industries/digital-businesses",
      en_AE: "/industries/digital-businesses",
      "en-SG": "/industries/digital-businesses",
      en_SG: "/industries/digital-businesses",
      "en-GB": "/industries/digital",
      en_GB: "/industries/digital"
    },
    "industries/food-and-beverage/index": {
      en: "/industries/food-and-beverage",
      "en-AU": "/industries/food-and-beverage",
      en_AU: "/industries/food-and-beverage",
      "pt-BR": "/setores/pagamentos-para-restaurantes",
      pt_BR: "/setores/pagamentos-para-restaurantes",
      "zh-CN": "/industries/food-and-beverage",
      zh_CN: "/industries/food-and-beverage",
      "cs-CZ": "/industries/platby-v-gastronomii",
      cs_CZ: "/industries/platby-v-gastronomii",
      "da-DK": "/industrier/mad-drikkevarer-betalinger",
      da_DK: "/industrier/mad-drikkevarer-betalinger",
      "de-DE": "/branchen/gastronomie-payments",
      de_DE: "/branchen/gastronomie-payments",
      "es-ES": "/sectores/restauracion",
      es_ES: "/sectores/restauracion",
      "fr-FR": "/secteurs/paiements-restauration",
      fr_FR: "/secteurs/paiements-restauration",
      "it-IT": "/settori/food-and-beverage",
      it_IT: "/settori/food-and-beverage",
      "ja-JP": "/industries/food-and-beverage",
      ja_JP: "/industries/food-and-beverage",
      "es-MX": "/industrias/food-and-beverage",
      es_MX: "/industrias/food-and-beverage",
      "nl-NL": "/industrieen/horeca",
      nl_NL: "/industrieen/horeca",
      "no-NO": "/bransjer/serveringsbransjen",
      no_NO: "/bransjer/serveringsbransjen",
      "pl-PL": "/branze/platnosci-gastronomia",
      pl_PL: "/branze/platnosci-gastronomia",
      "pt-PT": "/setores/food-and-beverage",
      pt_PT: "/setores/food-and-beverage",
      "sv-SE": "/branscher/betalningar-mat-dryck",
      sv_SE: "/branscher/betalningar-mat-dryck",
      "en-AE": "/industries/food-and-beverage",
      en_AE: "/industries/food-and-beverage",
      "en-SG": "/industries/food-and-beverage",
      en_SG: "/industries/food-and-beverage",
      "en-GB": "/industries/food-and-beverage",
      en_GB: "/industries/food-and-beverage"
    },
    "industries/hospitality/index": {
      en: "/industries/hospitality",
      "en-AU": "/industries/hospitality",
      en_AU: "/industries/hospitality",
      "pt-BR": "/setores/pagamentos-para-hotel",
      pt_BR: "/setores/pagamentos-para-hotel",
      "zh-CN": "/industries/hospitality",
      zh_CN: "/industries/hospitality",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/industrier/hotelbetalinger",
      da_DK: "/industrier/hotelbetalinger",
      "de-DE": "/branchen/hospitality",
      de_DE: "/branchen/hospitality",
      "es-ES": "/sectores/pagos-en-hoteles",
      es_ES: "/sectores/pagos-en-hoteles",
      "fr-FR": "/secteurs/paiements-hoteliers",
      fr_FR: "/secteurs/paiements-hoteliers",
      "it-IT": "/settori/pagamenti-hotel",
      it_IT: "/settori/pagamenti-hotel",
      "ja-JP": "/industries/hospitality",
      ja_JP: "/industries/hospitality",
      "es-MX": "/industrias/hospitality",
      es_MX: "/industrias/hospitality",
      "nl-NL": "/industrieen/hotelbetalingen",
      nl_NL: "/industrieen/hotelbetalingen",
      "no-NO": "/bransjer/hotell-betalinger",
      no_NO: "/bransjer/hotell-betalinger",
      "pl-PL": "/branze/platnosci-w-hotelach",
      pl_PL: "/branze/platnosci-w-hotelach",
      "pt-PT": "/setores/hotel-payments",
      pt_PT: "/setores/hotel-payments",
      "sv-SE": "/branscher/hotellbetalningar",
      sv_SE: "/branscher/hotellbetalningar",
      "en-AE": "/industries/hospitality",
      en_AE: "/industries/hospitality",
      "en-SG": "/industries/hospitality",
      en_SG: "/industries/hospitality",
      "en-GB": "/industries/hospitality",
      en_GB: "/industries/hospitality"
    },
    "industries/index": {
      en: "/industries",
      "en-AU": "/industries",
      en_AU: "/industries",
      "pt-BR": "/setores",
      pt_BR: "/setores",
      "zh-CN": "/industries",
      zh_CN: "/industries",
      "cs-CZ": "/industries",
      cs_CZ: "/industries",
      "da-DK": "/industrier",
      da_DK: "/industrier",
      "de-DE": "/branchen",
      de_DE: "/branchen",
      "es-ES": "/sectores",
      es_ES: "/sectores",
      "fr-FR": "/secteurs",
      fr_FR: "/secteurs",
      "it-IT": "/settori",
      it_IT: "/settori",
      "ja-JP": "/industries",
      ja_JP: "/industries",
      "es-MX": "/industrias",
      es_MX: "/industrias",
      "nl-NL": "/industrieen",
      nl_NL: "/industrieen",
      "no-NO": "/bransjer",
      no_NO: "/bransjer",
      "pl-PL": "/branze",
      pl_PL: "/branze",
      "pt-PT": "/setores",
      pt_PT: "/setores",
      "sv-SE": "/branscher",
      sv_SE: "/branscher",
      "en-AE": "/industries",
      en_AE: "/industries",
      "en-SG": "/industries",
      en_SG: "/industries",
      "en-GB": "/industries",
      en_GB: "/industries"
    },
    "industries/mobility/index": {
      en: "/industries/mobility",
      "en-AU": "/industries/mobility",
      en_AU: "/industries/mobility",
      "pt-BR": "/setores/pagamentos-mobilidade-urbana",
      pt_BR: "/setores/pagamentos-mobilidade-urbana",
      "zh-CN": "/industries/mobility",
      zh_CN: "/industries/mobility",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/industrier/mobilitet-betalinger",
      da_DK: "/industrier/mobilitet-betalinger",
      "de-DE": "/branchen/mobility",
      de_DE: "/branchen/mobility",
      "es-ES": "/sectores/palataforma-pagos-empresas-movilidad",
      es_ES: "/sectores/palataforma-pagos-empresas-movilidad",
      "fr-FR": "/secteurs/paiements-mobilite",
      fr_FR: "/secteurs/paiements-mobilite",
      "it-IT": "/settori/pagamenti-mobilita",
      it_IT: "/settori/pagamenti-mobilita",
      "ja-JP": "/industries/mobility",
      ja_JP: "/industries/mobility",
      "es-MX": "/industrias/mobility-payments",
      es_MX: "/industrias/mobility-payments",
      "nl-NL": "/industrieen/betalingen-in-de-mobiliteitsindustrie",
      nl_NL: "/industrieen/betalingen-in-de-mobiliteitsindustrie",
      "no-NO": "/bransjer/mobilitet-betalinger",
      no_NO: "/bransjer/mobilitet-betalinger",
      "pl-PL": "/branze/platnosci-w-transporci",
      pl_PL: "/branze/platnosci-w-transporci",
      "pt-PT": "/setores/mobility-payments",
      pt_PT: "/setores/mobility-payments",
      "sv-SE": "/branscher/betalningar-inom-transport",
      sv_SE: "/branscher/betalningar-inom-transport",
      "en-AE": "/industries/mobility",
      en_AE: "/industries/mobility",
      "en-SG": "/industries/mobility",
      en_SG: "/industries/mobility",
      "en-GB": "/industries/mobility",
      en_GB: "/industries/mobility"
    },
    "industries/omnichannel/index": {
      en: "/industries/omnichannel",
      "en-AU": "/industries/omnichannel",
      en_AU: "/industries/omnichannel",
      "pt-BR": "/setores/omnichannel",
      pt_BR: "/setores/omnichannel",
      "zh-CN": "/industries/omnichannel",
      zh_CN: "/industries/omnichannel",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/industrier/omnichannel",
      da_DK: "/industrier/omnichannel",
      "de-DE": "/branchen/omnichannel",
      de_DE: "/branchen/omnichannel",
      "es-ES": "/sectores/omnichannel",
      es_ES: "/sectores/omnichannel",
      "fr-FR": "/secteurs/omnichannel",
      fr_FR: "/secteurs/omnichannel",
      "it-IT": "/settori/omnichannel",
      it_IT: "/settori/omnichannel",
      "ja-JP": "/industries/omnichannel",
      ja_JP: "/industries/omnichannel",
      "es-MX": "/industrias/omnichannel",
      es_MX: "/industrias/omnichannel",
      "nl-NL": "/industrieen/omnichannel",
      nl_NL: "/industrieen/omnichannel",
      "no-NO": "/bransjer/omnichannel",
      no_NO: "/bransjer/omnichannel",
      "pl-PL": "/branze/omnichannel",
      pl_PL: "/branze/omnichannel",
      "pt-PT": "/setores/omnichannel",
      pt_PT: "/setores/omnichannel",
      "sv-SE": "/branscher/omnichannel",
      sv_SE: "/branscher/omnichannel",
      "en-AE": "/industries/omnichannel",
      en_AE: "/industries/omnichannel",
      "en-SG": "/industries/omnichannel",
      en_SG: "/industries/omnichannel",
      "en-GB": "/industries/omnichannel",
      en_GB: "/industries/omnichannel"
    },
    "industries/platforms/index": {
      en: "/industries/platforms",
      "en-AU": "/industries/platforms",
      en_AU: "/industries/platforms",
      "pt-BR": "/setores/platforms",
      pt_BR: "/setores/platforms",
      "zh-CN": "/industries/platforms",
      zh_CN: "/industries/platforms",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/industrier/platforms",
      da_DK: "/industrier/platforms",
      "de-DE": "/branchen/platforms",
      de_DE: "/branchen/platforms",
      "es-ES": "/sectores/platforms",
      es_ES: "/sectores/platforms",
      "fr-FR": "/secteurs/platforms",
      fr_FR: "/secteurs/platforms",
      "it-IT": "/settori/platforms",
      it_IT: "/settori/platforms",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/industrias/platforms",
      es_MX: "/industrias/platforms",
      "nl-NL": "/industrieen/platforms",
      nl_NL: "/industrieen/platforms",
      "no-NO": "/bransjer/platforms",
      no_NO: "/bransjer/platforms",
      "pl-PL": "/branze/platforms",
      pl_PL: "/branze/platforms",
      "pt-PT": "/setores/platforms",
      pt_PT: "/setores/platforms",
      "sv-SE": "/branscher/platforms",
      sv_SE: "/branscher/platforms",
      "en-AE": "/industries/platforms",
      en_AE: "/industries/platforms",
      "en-SG": "/industries/platforms",
      en_SG: "/industries/platforms",
      "en-GB": "/industries/platforms",
      en_GB: "/industries/platforms"
    },
    "industries/retail/index": {
      en: "/industries/retail",
      "en-AU": "/industries/retail",
      en_AU: "/industries/retail",
      "pt-BR": "/setores/pagamentos-para-varejo",
      pt_BR: "/setores/pagamentos-para-varejo",
      "zh-CN": "/industries/retail",
      zh_CN: "/industries/retail",
      "cs-CZ": "/industries/maloobchod",
      cs_CZ: "/industries/maloobchod",
      "da-DK": "/industrier/detailhandel-betalinger",
      da_DK: "/industrier/detailhandel-betalinger",
      "de-DE": "/branchen/retail",
      de_DE: "/branchen/retail",
      "es-ES": "/sectores/pagos-retail",
      es_ES: "/sectores/pagos-retail",
      "fr-FR": "/secteurs/retail",
      fr_FR: "/secteurs/retail",
      "it-IT": "/settori/retail-pagamenti",
      it_IT: "/settori/retail-pagamenti",
      "ja-JP": "/industries/retail",
      ja_JP: "/industries/retail",
      "es-MX": "/industrias/retail",
      es_MX: "/industrias/retail",
      "nl-NL": "/industrieen/retailbetalingen",
      nl_NL: "/industrieen/retailbetalingen",
      "no-NO": "/bransjer/detaljhandel-betalinger",
      no_NO: "/bransjer/detaljhandel-betalinger",
      "pl-PL": "/branze/platnosci-w-handlu",
      pl_PL: "/branze/platnosci-w-handlu",
      "pt-PT": "/setores/retail",
      pt_PT: "/setores/retail",
      "sv-SE": "/branscher/betalningar-i-detaljhandeln",
      sv_SE: "/branscher/betalningar-i-detaljhandeln",
      "en-AE": "/industries/retail",
      en_AE: "/industries/retail",
      "en-SG": "/industries/retail-payments",
      en_SG: "/industries/retail-payments",
      "en-GB": "/industries/retail",
      en_GB: "/industries/retail"
    },
    "industries/saas-platforms/index": {
      en: "/industries/saas-platforms",
      "en-AU": "/industries/saas-platforms",
      en_AU: "/industries/saas-platforms",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": "/industries/saas-platforms",
      en_SG: "/industries/saas-platforms",
      "en-GB": "/industries/saas-platforms",
      en_GB: "/industries/saas-platforms"
    },
    "industries/subscription/index": {
      en: "/industries/subscription",
      "en-AU": "/industries/subscription",
      en_AU: "/industries/subscription",
      "pt-BR": "/setores/assinatura",
      pt_BR: "/setores/assinatura",
      "zh-CN": "/industries/subscription",
      zh_CN: "/industries/subscription",
      "cs-CZ": "/industries/platby-formou-predplatneho",
      cs_CZ: "/industries/platby-formou-predplatneho",
      "da-DK": "/industrier/abonnement",
      da_DK: "/industrier/abonnement",
      "de-DE": "/branchen/abo-unternehmen",
      de_DE: "/branchen/abo-unternehmen",
      "es-ES": "/sectores/suscripciones",
      es_ES: "/sectores/suscripciones",
      "fr-FR": "/secteurs/abonnement",
      fr_FR: "/secteurs/abonnement",
      "it-IT": "/settori/abbonamenti",
      it_IT: "/settori/abbonamenti",
      "ja-JP": "/industries/subscription",
      ja_JP: "/industries/subscription",
      "es-MX": "/industrias/subscription",
      es_MX: "/industrias/subscription",
      "nl-NL": "/industrieen/abonnement",
      nl_NL: "/industrieen/abonnement",
      "no-NO": "/bransjer/abonnement",
      no_NO: "/bransjer/abonnement",
      "pl-PL": "/branze/platnosci-subskrypcyjne-i-cykliczne",
      pl_PL: "/branze/platnosci-subskrypcyjne-i-cykliczne",
      "pt-PT": "/setores/assinatura",
      pt_PT: "/setores/assinatura",
      "sv-SE": "/branscher/prenumeration",
      sv_SE: "/branscher/prenumeration",
      "en-AE": "/industries/subscription",
      en_AE: "/industries/subscription",
      "en-SG": "/industries/subscription-payments",
      en_SG: "/industries/subscription-payments",
      "en-GB": "/industries/subscription",
      en_GB: "/industries/subscription"
    },
    "infrastructure/index": {
      en: "/infrastructure",
      "en-AU": "/infrastructure",
      en_AU: "/infrastructure",
      "pt-BR": "/infraestrutura",
      pt_BR: "/infraestrutura",
      "zh-CN": "/infrastructure",
      zh_CN: "/infrastructure",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/infrastruktur",
      da_DK: "/infrastruktur",
      "de-DE": "/infrastruktur",
      de_DE: "/infrastruktur",
      "es-ES": "/infraestructura",
      es_ES: "/infraestructura",
      "fr-FR": "/infrastructure",
      fr_FR: "/infrastructure",
      "it-IT": "/infrastruttura",
      it_IT: "/infrastruttura",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/infrastructure",
      es_MX: "/infrastructure",
      "nl-NL": "/infrastructuur",
      nl_NL: "/infrastructuur",
      "no-NO": "/infrastruktur",
      no_NO: "/infrastruktur",
      "pl-PL": "/infrastruktura",
      pl_PL: "/infrastruktura",
      "pt-PT": "/infrastructure",
      pt_PT: "/infrastructure",
      "sv-SE": "/infrastruktur",
      sv_SE: "/infrastruktur",
      "en-AE": "/infrastructure",
      en_AE: "/infrastructure",
      "en-SG": false,
      en_SG: false,
      "en-GB": "/infrastructure",
      en_GB: "/infrastructure"
    },
    "issuing/index": {
      en: "/issuing",
      "en-AU": "/issuing",
      en_AU: "/issuing",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": "/issuing",
      zh_CN: "/issuing",
      "cs-CZ": "/issuing",
      cs_CZ: "/issuing",
      "da-DK": "/udstedelse",
      da_DK: "/udstedelse",
      "de-DE": "/card-issuing",
      de_DE: "/card-issuing",
      "es-ES": "/emision-de-tarjetas",
      es_ES: "/emision-de-tarjetas",
      "fr-FR": "/emission-carte",
      fr_FR: "/emission-carte",
      "it-IT": "/issuing",
      it_IT: "/issuing",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/issuing",
      nl_NL: "/issuing",
      "no-NO": "/utstedelse",
      no_NO: "/utstedelse",
      "pl-PL": "/wydawanie-kart",
      pl_PL: "/wydawanie-kart",
      "pt-PT": "/issuing",
      pt_PT: "/issuing",
      "sv-SE": "/kortutgivning",
      sv_SE: "/kortutgivning",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/issuing",
      en_SG: "/issuing",
      "en-GB": "/issuing",
      en_GB: "/issuing"
    },
    "landing/[slug]": {
      en: "/landing/[slug]",
      "en-AU": "/landing/[slug]",
      en_AU: "/landing/[slug]",
      "pt-BR": "/landing/[slug]",
      pt_BR: "/landing/[slug]",
      "zh-CN": "/landing/[slug]",
      zh_CN: "/landing/[slug]",
      "cs-CZ": "/landing/[slug]",
      cs_CZ: "/landing/[slug]",
      "da-DK": "/landing/[slug]",
      da_DK: "/landing/[slug]",
      "de-DE": "/landing/[slug]",
      de_DE: "/landing/[slug]",
      "es-ES": "/landing/[slug]",
      es_ES: "/landing/[slug]",
      "fr-FR": "/landing/[slug]",
      fr_FR: "/landing/[slug]",
      "it-IT": "/landing/[slug]",
      it_IT: "/landing/[slug]",
      "ja-JP": "/landing/[slug]",
      ja_JP: "/landing/[slug]",
      "es-MX": "/landing/[slug]",
      es_MX: "/landing/[slug]",
      "nl-NL": "/landing/[slug]",
      nl_NL: "/landing/[slug]",
      "no-NO": "/landing/[slug]",
      no_NO: "/landing/[slug]",
      "pl-PL": "/landing/[slug]",
      pl_PL: "/landing/[slug]",
      "pt-PT": "/landing/[slug]",
      pt_PT: "/landing/[slug]",
      "sv-SE": "/landing/[slug]",
      sv_SE: "/landing/[slug]",
      "en-AE": "/landing/[slug]",
      en_AE: "/landing/[slug]",
      "en-SG": "/landing/[slug]",
      en_SG: "/landing/[slug]",
      "en-GB": "/landing/[slug]",
      en_GB: "/landing/[slug]"
    },
    "landing/business-value-[campaign]": {
      en: "/landing/business-value-[campaign]",
      "en-AU": "/landing/business-value-[campaign]",
      en_AU: "/landing/business-value-[campaign]",
      "pt-BR": "/landing/business-value-[campaign]",
      pt_BR: "/landing/business-value-[campaign]",
      "zh-CN": "/landing/business-value-[campaign]",
      zh_CN: "/landing/business-value-[campaign]",
      "cs-CZ": "/landing/business-value-[campaign]",
      cs_CZ: "/landing/business-value-[campaign]",
      "da-DK": "/landing/business-value-[campaign]",
      da_DK: "/landing/business-value-[campaign]",
      "de-DE": "/landing/business-value-[campaign]",
      de_DE: "/landing/business-value-[campaign]",
      "es-ES": "/landing/business-value-[campaign]",
      es_ES: "/landing/business-value-[campaign]",
      "fr-FR": "/landing/business-value-[campaign]",
      fr_FR: "/landing/business-value-[campaign]",
      "it-IT": "/landing/business-value-[campaign]",
      it_IT: "/landing/business-value-[campaign]",
      "ja-JP": "/landing/business-value-[campaign]",
      ja_JP: "/landing/business-value-[campaign]",
      "es-MX": "/landing/business-value-[campaign]",
      es_MX: "/landing/business-value-[campaign]",
      "nl-NL": "/landing/business-value-[campaign]",
      nl_NL: "/landing/business-value-[campaign]",
      "no-NO": "/landing/business-value-[campaign]",
      no_NO: "/landing/business-value-[campaign]",
      "pl-PL": "/landing/business-value-[campaign]",
      pl_PL: "/landing/business-value-[campaign]",
      "pt-PT": "/landing/business-value-[campaign]",
      pt_PT: "/landing/business-value-[campaign]",
      "sv-SE": "/landing/business-value-[campaign]",
      sv_SE: "/landing/business-value-[campaign]",
      "en-AE": "/landing/business-value-[campaign]",
      en_AE: "/landing/business-value-[campaign]",
      "en-SG": "/landing/business-value-[campaign]",
      en_SG: "/landing/business-value-[campaign]",
      "en-GB": "/landing/business-value-[campaign]",
      en_GB: "/landing/business-value-[campaign]"
    },
    "landing/index": {
      en: "/landing",
      "en-AU": "/landing",
      en_AU: "/landing",
      "pt-BR": "/landing",
      pt_BR: "/landing",
      "zh-CN": "/landing",
      zh_CN: "/landing",
      "cs-CZ": "/landing",
      cs_CZ: "/landing",
      "da-DK": "/landing",
      da_DK: "/landing",
      "de-DE": "/landing",
      de_DE: "/landing",
      "es-ES": "/landing",
      es_ES: "/landing",
      "fr-FR": "/landing",
      fr_FR: "/landing",
      "it-IT": "/landing",
      it_IT: "/landing",
      "ja-JP": "/landing",
      ja_JP: "/landing",
      "es-MX": "/landing",
      es_MX: "/landing",
      "nl-NL": "/landing",
      nl_NL: "/landing",
      "no-NO": "/landing",
      no_NO: "/landing",
      "pl-PL": "/landing",
      pl_PL: "/landing",
      "pt-PT": "/landing",
      pt_PT: "/landing",
      "sv-SE": "/landing",
      sv_SE: "/landing",
      "en-AE": "/landing",
      en_AE: "/landing",
      "en-SG": "/landing",
      en_SG: "/landing",
      "en-GB": "/landing",
      en_GB: "/landing"
    },
    "landing/team-italia": {
      en: "/landing/team-italia",
      "en-AU": "/landing/team-italia",
      en_AU: "/landing/team-italia",
      "pt-BR": "/landing/team-italia",
      pt_BR: "/landing/team-italia",
      "zh-CN": "/landing/team-italia",
      zh_CN: "/landing/team-italia",
      "cs-CZ": "/landing/team-italia",
      cs_CZ: "/landing/team-italia",
      "da-DK": "/landing/team-italia",
      da_DK: "/landing/team-italia",
      "de-DE": "/landing/team-italia",
      de_DE: "/landing/team-italia",
      "es-ES": "/landing/team-italia",
      es_ES: "/landing/team-italia",
      "fr-FR": "/landing/team-italia",
      fr_FR: "/landing/team-italia",
      "it-IT": "/landing/team-italia",
      it_IT: "/landing/team-italia",
      "ja-JP": "/landing/team-italia",
      ja_JP: "/landing/team-italia",
      "es-MX": "/landing/team-italia",
      es_MX: "/landing/team-italia",
      "nl-NL": "/landing/team-italia",
      nl_NL: "/landing/team-italia",
      "no-NO": "/landing/team-italia",
      no_NO: "/landing/team-italia",
      "pl-PL": "/landing/team-italia",
      pl_PL: "/landing/team-italia",
      "pt-PT": "/landing/team-italia",
      pt_PT: "/landing/team-italia",
      "sv-SE": "/landing/team-italia",
      sv_SE: "/landing/team-italia",
      "en-AE": "/landing/team-italia",
      en_AE: "/landing/team-italia",
      "en-SG": "/landing/team-italia",
      en_SG: "/landing/team-italia",
      "en-GB": "/landing/team-italia",
      en_GB: "/landing/team-italia"
    },
    "legal/[slug]": {
      en: "/legal/[slug]",
      "en-AU": "/legal/[slug]",
      en_AU: "/legal/[slug]",
      "pt-BR": "/legal/[slug]",
      pt_BR: "/legal/[slug]",
      "zh-CN": "/legal/[slug]",
      zh_CN: "/legal/[slug]",
      "cs-CZ": "/legal/[slug]",
      cs_CZ: "/legal/[slug]",
      "da-DK": "/legal/[slug]",
      da_DK: "/legal/[slug]",
      "de-DE": "/legal/[slug]",
      de_DE: "/legal/[slug]",
      "es-ES": "/legal/[slug]",
      es_ES: "/legal/[slug]",
      "fr-FR": "/legal/[slug]",
      fr_FR: "/legal/[slug]",
      "it-IT": "/legal/[slug]",
      it_IT: "/legal/[slug]",
      "ja-JP": "/legal/[slug]",
      ja_JP: "/legal/[slug]",
      "es-MX": "/legal/[slug]",
      es_MX: "/legal/[slug]",
      "nl-NL": "/legal/[slug]",
      nl_NL: "/legal/[slug]",
      "no-NO": "/legal/[slug]",
      no_NO: "/legal/[slug]",
      "pl-PL": "/legal/[slug]",
      pl_PL: "/legal/[slug]",
      "pt-PT": "/legal/[slug]",
      pt_PT: "/legal/[slug]",
      "sv-SE": "/legal/[slug]",
      sv_SE: "/legal/[slug]",
      "en-AE": "/legal/[slug]",
      en_AE: "/legal/[slug]",
      "en-SG": "/legal/[slug]",
      en_SG: "/legal/[slug]",
      "en-GB": "/legal/[slug]",
      en_GB: "/legal/[slug]"
    },
    "legal/index": {
      en: "/legal",
      "en-AU": "/legal",
      en_AU: "/legal",
      "pt-BR": "/legal",
      pt_BR: "/legal",
      "zh-CN": "/legal",
      zh_CN: "/legal",
      "cs-CZ": "/legal",
      cs_CZ: "/legal",
      "da-DK": "/legal",
      da_DK: "/legal",
      "de-DE": "/legal",
      de_DE: "/legal",
      "es-ES": "/legal",
      es_ES: "/legal",
      "fr-FR": "/legal",
      fr_FR: "/legal",
      "it-IT": "/legal",
      it_IT: "/legal",
      "ja-JP": "/legal",
      ja_JP: "/legal",
      "es-MX": "/legal",
      es_MX: "/legal",
      "nl-NL": "/legal",
      nl_NL: "/legal",
      "no-NO": "/legal",
      no_NO: "/legal",
      "pl-PL": "/legal",
      pl_PL: "/legal",
      "pt-PT": "/legal",
      pt_PT: "/legal",
      "sv-SE": "/legal",
      sv_SE: "/legal",
      "en-AE": "/legal",
      en_AE: "/legal",
      "en-SG": "/legal",
      en_SG: "/legal",
      "en-GB": "/legal",
      en_GB: "/legal"
    },
    "licenses/[slug]": {
      en: "/licenses/[slug]",
      "en-AU": "/licenses/[slug]",
      en_AU: "/licenses/[slug]",
      "pt-BR": "/licencas/[slug]",
      pt_BR: "/licencas/[slug]",
      "zh-CN": "/licenses/[slug]",
      zh_CN: "/licenses/[slug]",
      "cs-CZ": "/licenses/[slug]",
      cs_CZ: "/licenses/[slug]",
      "da-DK": "/licenser/[slug]",
      da_DK: "/licenser/[slug]",
      "de-DE": "/lizenzen/[slug]",
      de_DE: "/lizenzen/[slug]",
      "es-ES": "/licenses/[slug]",
      es_ES: "/licenses/[slug]",
      "fr-FR": "/licences/[slug]",
      fr_FR: "/licences/[slug]",
      "it-IT": "/licenze/[slug]",
      it_IT: "/licenze/[slug]",
      "ja-JP": "/licenses/[slug]",
      ja_JP: "/licenses/[slug]",
      "es-MX": "/licenses/[slug]",
      es_MX: "/licenses/[slug]",
      "nl-NL": "/licenses/[slug]",
      nl_NL: "/licenses/[slug]",
      "no-NO": "/lisenser/[slug]",
      no_NO: "/lisenser/[slug]",
      "pl-PL": "/licencje/[slug]",
      pl_PL: "/licencje/[slug]",
      "pt-PT": "/licencas/[slug]",
      pt_PT: "/licencas/[slug]",
      "sv-SE": "/licenser/[slug]",
      sv_SE: "/licenser/[slug]",
      "en-AE": "/licenses/[slug]",
      en_AE: "/licenses/[slug]",
      "en-SG": false,
      en_SG: false,
      "en-GB": "/licenses/[slug]",
      en_GB: "/licenses/[slug]"
    },
    "licenses/index": {
      en: "/licenses",
      "en-AU": "/licenses",
      en_AU: "/licenses",
      "pt-BR": "/licencas",
      pt_BR: "/licencas",
      "zh-CN": "/licenses",
      zh_CN: "/licenses",
      "cs-CZ": "/licenses",
      cs_CZ: "/licenses",
      "da-DK": "/licenser",
      da_DK: "/licenser",
      "de-DE": "/lizenzen",
      de_DE: "/lizenzen",
      "es-ES": "/licenses",
      es_ES: "/licenses",
      "fr-FR": "/licences",
      fr_FR: "/licences",
      "it-IT": "/licenze",
      it_IT: "/licenze",
      "ja-JP": "/licenses",
      ja_JP: "/licenses",
      "es-MX": "/licenses",
      es_MX: "/licenses",
      "nl-NL": "/licenses",
      nl_NL: "/licenses",
      "no-NO": "/lisenser",
      no_NO: "/lisenser",
      "pl-PL": "/licencje",
      pl_PL: "/licencje",
      "pt-PT": "/licencas",
      pt_PT: "/licencas",
      "sv-SE": "/licenser",
      sv_SE: "/licenser",
      "en-AE": "/licenses",
      en_AE: "/licenses",
      "en-SG": false,
      en_SG: false,
      "en-GB": "/licenses",
      en_GB: "/licenses"
    },
    "manuals/[slug]": {
      en: "/manuals/[slug]",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "manuals/index": {
      en: "/manuals",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "newsletter/[slug]": {
      en: "/newsletter/[slug]",
      "en-AU": "/newsletter/[slug]",
      en_AU: "/newsletter/[slug]",
      "pt-BR": "/newsletter/[slug]",
      pt_BR: "/newsletter/[slug]",
      "zh-CN": "/newsletter/[slug]",
      zh_CN: "/newsletter/[slug]",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/nyhedsbrev/[slug]",
      da_DK: "/nyhedsbrev/[slug]",
      "de-DE": "/newsletter/[slug]",
      de_DE: "/newsletter/[slug]",
      "es-ES": "/newsletter/[slug]",
      es_ES: "/newsletter/[slug]",
      "fr-FR": "/newsletter/[slug]",
      fr_FR: "/newsletter/[slug]",
      "it-IT": "/newsletter/[slug]",
      it_IT: "/newsletter/[slug]",
      "ja-JP": "/newsletter/[slug]",
      ja_JP: "/newsletter/[slug]",
      "es-MX": "/newsletter/[slug]",
      es_MX: "/newsletter/[slug]",
      "nl-NL": "/newsletter/[slug]",
      nl_NL: "/newsletter/[slug]",
      "no-NO": "/nyhetsbrev/[slug]",
      no_NO: "/nyhetsbrev/[slug]",
      "pl-PL": "/newsletter/[slug]",
      pl_PL: "/newsletter/[slug]",
      "pt-PT": "/newsletter/[slug]",
      pt_PT: "/newsletter/[slug]",
      "sv-SE": "/nyhetsbrev/[slug]",
      sv_SE: "/nyhetsbrev/[slug]",
      "en-AE": "/newsletter/[slug]",
      en_AE: "/newsletter/[slug]",
      "en-SG": "/newsletter/[slug]",
      en_SG: "/newsletter/[slug]",
      "en-GB": "/newsletter/[slug]",
      en_GB: "/newsletter/[slug]"
    },
    "newsletter/index": {
      en: "/newsletter",
      "en-AU": "/newsletter",
      en_AU: "/newsletter",
      "pt-BR": "/newsletter",
      pt_BR: "/newsletter",
      "zh-CN": "/newsletter",
      zh_CN: "/newsletter",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/nyhedsbrev",
      da_DK: "/nyhedsbrev",
      "de-DE": "/newsletter",
      de_DE: "/newsletter",
      "es-ES": "/newsletter",
      es_ES: "/newsletter",
      "fr-FR": "/newsletter",
      fr_FR: "/newsletter",
      "it-IT": "/newsletter",
      it_IT: "/newsletter",
      "ja-JP": "/newsletter",
      ja_JP: "/newsletter",
      "es-MX": "/newsletter",
      es_MX: "/newsletter",
      "nl-NL": "/newsletter",
      nl_NL: "/newsletter",
      "no-NO": "/nyhetsbrev",
      no_NO: "/nyhetsbrev",
      "pl-PL": "/newsletter",
      pl_PL: "/newsletter",
      "pt-PT": "/newsletter",
      pt_PT: "/newsletter",
      "sv-SE": "/nyhetsbrev",
      sv_SE: "/nyhetsbrev",
      "en-AE": "/newsletter",
      en_AE: "/newsletter",
      "en-SG": "/newsletter",
      en_SG: "/newsletter",
      "en-GB": "/newsletter",
      en_GB: "/newsletter"
    },
    "offices/index": {
      en: "/offices",
      "en-AU": "/offices",
      en_AU: "/offices",
      "pt-BR": "/escritorios",
      pt_BR: "/escritorios",
      "zh-CN": "/offices",
      zh_CN: "/offices",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/kontorer",
      da_DK: "/kontorer",
      "de-DE": "/standorte",
      de_DE: "/standorte",
      "es-ES": "/oficinas",
      es_ES: "/oficinas",
      "fr-FR": "/bureaux",
      fr_FR: "/bureaux",
      "it-IT": "/uffici",
      it_IT: "/uffici",
      "ja-JP": "/offices",
      ja_JP: "/offices",
      "es-MX": "/oficinas",
      es_MX: "/oficinas",
      "nl-NL": "/kantoren",
      nl_NL: "/kantoren",
      "no-NO": "/kontorer",
      no_NO: "/kontorer",
      "pl-PL": "/biura",
      pl_PL: "/biura",
      "pt-PT": "/escritorios",
      pt_PT: "/escritorios",
      "sv-SE": "/kontor",
      sv_SE: "/kontor",
      "en-AE": "/offices",
      en_AE: "/offices",
      "en-SG": "/offices",
      en_SG: "/offices",
      "en-GB": "/offices",
      en_GB: "/offices"
    },
    "online-payments/in-app/index": {
      en: "/online-payments/in-app",
      "en-AU": "/online-payments/in-app",
      en_AU: "/online-payments/in-app",
      "pt-BR": "/pagamentos-online/in-app",
      pt_BR: "/pagamentos-online/in-app",
      "zh-CN": "/online-payments/in-app",
      zh_CN: "/online-payments/in-app",
      "cs-CZ": "/online-platebni-brana/platby-v-aplikaci",
      cs_CZ: "/online-platebni-brana/platby-v-aplikaci",
      "da-DK": "/online-betalinger/i-app",
      da_DK: "/online-betalinger/i-app",
      "de-DE": "/online-zahlungen/in-app-zahlungen",
      de_DE: "/online-zahlungen/in-app-zahlungen",
      "es-ES": "/tpv-virtual/in-app",
      es_ES: "/tpv-virtual/in-app",
      "fr-FR": "/paiements-en-ligne/in-app",
      fr_FR: "/paiements-en-ligne/in-app",
      "it-IT": "/pagamenti-online/in-app",
      it_IT: "/pagamenti-online/in-app",
      "ja-JP": "/online-payments/in-app",
      ja_JP: "/online-payments/in-app",
      "es-MX": "/pagos-online/en-app",
      es_MX: "/pagos-online/en-app",
      "nl-NL": "/online-betalingen/in-app",
      nl_NL: "/online-betalingen/in-app",
      "no-NO": "/checkout/i-app",
      no_NO: "/checkout/i-app",
      "pl-PL": "/platnosci-online/w-aplikacji",
      pl_PL: "/platnosci-online/w-aplikacji",
      "pt-PT": "/pagamentos-online/in-app",
      pt_PT: "/pagamentos-online/in-app",
      "sv-SE": "/checkout/inuti-app",
      sv_SE: "/checkout/inuti-app",
      "en-AE": "/online-payments/in-app",
      en_AE: "/online-payments/in-app",
      "en-SG": "/online-payments/in-app",
      en_SG: "/online-payments/in-app",
      "en-GB": "/online-payments/in-app",
      en_GB: "/online-payments/in-app"
    },
    "online-payments/index": {
      en: "/online-payments",
      "en-AU": "/online-payments",
      en_AU: "/online-payments",
      "pt-BR": "/pagamentos-online",
      pt_BR: "/pagamentos-online",
      "zh-CN": "/online-payments",
      zh_CN: "/online-payments",
      "cs-CZ": "/online-platebni-brana",
      cs_CZ: "/online-platebni-brana",
      "da-DK": "/online-betalinger",
      da_DK: "/online-betalinger",
      "de-DE": "/online-zahlungen",
      de_DE: "/online-zahlungen",
      "es-ES": "/tpv-virtual",
      es_ES: "/tpv-virtual",
      "fr-FR": "/paiements-en-ligne",
      fr_FR: "/paiements-en-ligne",
      "it-IT": "/pagamenti-online",
      it_IT: "/pagamenti-online",
      "ja-JP": "/online-payments",
      ja_JP: "/online-payments",
      "es-MX": "/pagos-online",
      es_MX: "/pagos-online",
      "nl-NL": "/online-betalingen",
      nl_NL: "/online-betalingen",
      "no-NO": "/checkout",
      no_NO: "/checkout",
      "pl-PL": "/platnosci-online",
      pl_PL: "/platnosci-online",
      "pt-PT": "/pagamentos-online",
      pt_PT: "/pagamentos-online",
      "sv-SE": "/checkout",
      sv_SE: "/checkout",
      "en-AE": "/online-payments",
      en_AE: "/online-payments",
      "en-SG": "/online-payments",
      en_SG: "/online-payments",
      "en-GB": "/online-payments",
      en_GB: "/online-payments"
    },
    "partners/[slug]": {
      en: "/partners/[slug]",
      "en-AU": "/partners/[slug]",
      en_AU: "/partners/[slug]",
      "pt-BR": "/parceiros/[slug]",
      pt_BR: "/parceiros/[slug]",
      "zh-CN": "/partners/[slug]",
      zh_CN: "/partners/[slug]",
      "cs-CZ": "/partners/[slug]",
      cs_CZ: "/partners/[slug]",
      "da-DK": "/partnere/[slug]",
      da_DK: "/partnere/[slug]",
      "de-DE": "/partner/[slug]",
      de_DE: "/partner/[slug]",
      "es-ES": "/partners/[slug]",
      es_ES: "/partners/[slug]",
      "fr-FR": "/partenaires/[slug]",
      fr_FR: "/partenaires/[slug]",
      "it-IT": "/partner/[slug]",
      it_IT: "/partner/[slug]",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/partners/[slug]",
      nl_NL: "/partners/[slug]",
      "no-NO": "/partnere/[slug]",
      no_NO: "/partnere/[slug]",
      "pl-PL": "/partnerzy/[slug]",
      pl_PL: "/partnerzy/[slug]",
      "pt-PT": "/partners/[slug]",
      pt_PT: "/partners/[slug]",
      "sv-SE": "/partner/[slug]",
      sv_SE: "/partner/[slug]",
      "en-AE": "/partners/[slug]",
      en_AE: "/partners/[slug]",
      "en-SG": "/partners/[slug]",
      en_SG: "/partners/[slug]",
      "en-GB": "/partners/[slug]",
      en_GB: "/partners/[slug]"
    },
    "partners/index": {
      en: "/partners",
      "en-AU": "/partners",
      en_AU: "/partners",
      "pt-BR": "/parceiros",
      pt_BR: "/parceiros",
      "zh-CN": "/partners",
      zh_CN: "/partners",
      "cs-CZ": "/partners",
      cs_CZ: "/partners",
      "da-DK": "/partnere",
      da_DK: "/partnere",
      "de-DE": "/partner",
      de_DE: "/partner",
      "es-ES": "/partners",
      es_ES: "/partners",
      "fr-FR": "/partenaires",
      fr_FR: "/partenaires",
      "it-IT": "/partner",
      it_IT: "/partner",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/partners",
      nl_NL: "/partners",
      "no-NO": "/partnere",
      no_NO: "/partnere",
      "pl-PL": "/partnerzy",
      pl_PL: "/partnerzy",
      "pt-PT": "/partners",
      pt_PT: "/partners",
      "sv-SE": "/partner",
      sv_SE: "/partner",
      "en-AE": "/partners",
      en_AE: "/partners",
      "en-SG": "/partners",
      en_SG: "/partners",
      "en-GB": "/partners",
      en_GB: "/partners"
    },
    "partners/network/index": {
      en: "/partners/network",
      "en-AU": "/partners/network",
      en_AU: "/partners/network",
      "pt-BR": "/parceiros/rede",
      pt_BR: "/parceiros/rede",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/partnere/partnere",
      da_DK: "/partnere/partnere",
      "de-DE": "/partner/network",
      de_DE: "/partner/network",
      "es-ES": "/partners/network",
      es_ES: "/partners/network",
      "fr-FR": "/partenaires/network",
      fr_FR: "/partenaires/network",
      "it-IT": "/partner/network",
      it_IT: "/partner/network",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/partners/network",
      nl_NL: "/partners/network",
      "no-NO": "/partnere/nettverk",
      no_NO: "/partnere/nettverk",
      "pl-PL": "/partnerzy/siec",
      pl_PL: "/partnerzy/siec",
      "pt-PT": "/partners/rede",
      pt_PT: "/partners/rede",
      "sv-SE": "/partner/network",
      sv_SE: "/partner/network",
      "en-AE": "/partners/network",
      en_AE: "/partners/network",
      "en-SG": "/partners/network",
      en_SG: "/partners/network",
      "en-GB": "/partners/network",
      en_GB: "/partners/network"
    },
    "pay-by-link/index": {
      en: "/pay-by-link",
      "en-AU": "/pay-by-link",
      en_AU: "/pay-by-link",
      "pt-BR": "/link-de-pagamento",
      pt_BR: "/link-de-pagamento",
      "zh-CN": "/pay-by-link",
      zh_CN: "/pay-by-link",
      "cs-CZ": "/platebni-odkaz",
      cs_CZ: "/platebni-odkaz",
      "da-DK": "/betalingslink",
      da_DK: "/betalingslink",
      "de-DE": "/pay-by-link",
      de_DE: "/pay-by-link",
      "es-ES": "/link-de-pago",
      es_ES: "/link-de-pago",
      "fr-FR": "/pay-by-link",
      fr_FR: "/pay-by-link",
      "it-IT": "/paga-tramite-link",
      it_IT: "/paga-tramite-link",
      "ja-JP": "/pay-by-link",
      ja_JP: "/pay-by-link",
      "es-MX": "/pay-by-link",
      es_MX: "/pay-by-link",
      "nl-NL": "/pay-by-link",
      nl_NL: "/pay-by-link",
      "no-NO": "/betalingslenke",
      no_NO: "/betalingslenke",
      "pl-PL": "/pay-by-link",
      pl_PL: "/pay-by-link",
      "pt-PT": "/pay-by-link",
      pt_PT: "/pay-by-link",
      "sv-SE": "/betallank",
      sv_SE: "/betallank",
      "en-AE": "/pay-by-link",
      en_AE: "/pay-by-link",
      "en-SG": "/pay-by-link",
      en_SG: "/pay-by-link",
      "en-GB": "/pay-by-link",
      en_GB: "/pay-by-link"
    },
    "payouts/index": {
      en: "/payouts",
      "en-AU": "/payouts",
      en_AU: "/payouts",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/udbetalinger",
      da_DK: "/udbetalinger",
      "de-DE": "/payouts",
      de_DE: "/payouts",
      "es-ES": "/de-pagos",
      es_ES: "/de-pagos",
      "fr-FR": "/payouts",
      fr_FR: "/payouts",
      "it-IT": "/pagamenti",
      it_IT: "/pagamenti",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/payouts",
      nl_NL: "/payouts",
      "no-NO": "/utbetalinger",
      no_NO: "/utbetalinger",
      "pl-PL": "/wyplaty",
      pl_PL: "/wyplaty",
      "pt-PT": "/liquidacoes",
      pt_PT: "/liquidacoes",
      "sv-SE": "/utbetalningar",
      sv_SE: "/utbetalningar",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/payouts",
      en_SG: "/payouts",
      "en-GB": "/payouts",
      en_GB: "/payouts"
    },
    "platform-directory/index": {
      en: "/platform-directory",
      "en-AU": "/platform-directory",
      en_AU: "/platform-directory",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/platform-directory",
      da_DK: "/platform-directory",
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": "/platform-directory",
      no_NO: "/platform-directory",
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": "/plattformskatalog",
      sv_SE: "/plattformskatalog",
      "en-AE": "/platform-directory",
      en_AE: "/platform-directory",
      "en-SG": "/platform-directory",
      en_SG: "/platform-directory",
      "en-GB": "/platform-directory",
      en_GB: "/platform-directory"
    },
    "platform-payments/index": {
      en: "/platform-payments",
      "en-AU": "/platform-payments",
      en_AU: "/platform-payments",
      "pt-BR": "/platform-payments",
      pt_BR: "/platform-payments",
      "zh-CN": "/platform-payments",
      zh_CN: "/platform-payments",
      "cs-CZ": "/platby-pro-trziste",
      cs_CZ: "/platby-pro-trziste",
      "da-DK": "/markedspladser-og-platforme",
      da_DK: "/markedspladser-og-platforme",
      "de-DE": "/plattformen",
      de_DE: "/plattformen",
      "es-ES": "/plataformas",
      es_ES: "/plataformas",
      "fr-FR": "/paiements-plateformes",
      fr_FR: "/paiements-plateformes",
      "it-IT": "/piattaforme",
      it_IT: "/piattaforme",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/platform-payments",
      es_MX: "/platform-payments",
      "nl-NL": "/platform-payments",
      nl_NL: "/platform-payments",
      "no-NO": "/markedsplasser-og-plattformer",
      no_NO: "/markedsplasser-og-plattformer",
      "pl-PL": "/platformy-marketplace-i-handlowe",
      pl_PL: "/platformy-marketplace-i-handlowe",
      "pt-PT": "/platform-payments",
      pt_PT: "/platform-payments",
      "sv-SE": "/plattformar",
      sv_SE: "/plattformar",
      "en-AE": false,
      en_AE: false,
      "en-SG": "/platform-payments",
      en_SG: "/platform-payments",
      "en-GB": "/platform-payments",
      en_GB: "/platform-payments"
    },
    "plugins/index": {
      en: "/plugins",
      "en-AU": "/plugins",
      en_AU: "/plugins",
      "pt-BR": "/plugins",
      pt_BR: "/plugins",
      "zh-CN": "/plugins",
      zh_CN: "/plugins",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/plugins",
      da_DK: "/plugins",
      "de-DE": "/plugins",
      de_DE: "/plugins",
      "es-ES": "/plugins",
      es_ES: "/plugins",
      "fr-FR": "/plugins",
      fr_FR: "/plugins",
      "it-IT": "/plug-in",
      it_IT: "/plug-in",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/plugins",
      es_MX: "/plugins",
      "nl-NL": "/plug-ins",
      nl_NL: "/plug-ins",
      "no-NO": "/programtillegg",
      no_NO: "/programtillegg",
      "pl-PL": "/platnosci-wtyczki-e-commerce",
      pl_PL: "/platnosci-wtyczki-e-commerce",
      "pt-PT": "/plug-ins",
      pt_PT: "/plug-ins",
      "sv-SE": "/plugin",
      sv_SE: "/plugin",
      "en-AE": "/plugins",
      en_AE: "/plugins",
      "en-SG": "/plugins",
      en_SG: "/plugins",
      "en-GB": "/plugins",
      en_GB: "/plugins"
    },
    "podcast/[episode]/[slug]": {
      en: "/podcast/[episode]/[slug]",
      "en-AU": "/podcast/[episode]/[slug]",
      en_AU: "/podcast/[episode]/[slug]",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "podcast/[slug]": {
      en: "/podcast/[slug]",
      "en-AU": "/podcast/[slug]",
      en_AU: "/podcast/[slug]",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "podcast/index": {
      en: "/podcast",
      "en-AU": "/podcast",
      en_AU: "/podcast",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "policies-and-disclaimer/[slug]": {
      en: "/policies-and-disclaimer/[slug]",
      "en-AU": "/policies-and-disclaimer/[slug]",
      en_AU: "/policies-and-disclaimer/[slug]",
      "pt-BR": "/politicas-e-termo-de-responsabilidade/[slug]",
      pt_BR: "/politicas-e-termo-de-responsabilidade/[slug]",
      "zh-CN": "/policies-and-disclaimer/[slug]",
      zh_CN: "/policies-and-disclaimer/[slug]",
      "cs-CZ": "/policies-and-disclaimer/[slug]",
      cs_CZ: "/policies-and-disclaimer/[slug]",
      "da-DK": "/policies-and-disclaimer/[slug]",
      da_DK: "/policies-and-disclaimer/[slug]",
      "de-DE": "/richtlinien-und-haftungsausschluss/[slug]",
      de_DE: "/richtlinien-und-haftungsausschluss/[slug]",
      "es-ES": "/policies-and-disclaimer/[slug]",
      es_ES: "/policies-and-disclaimer/[slug]",
      "fr-FR": "/politiques-et-mentions-legales/[slug]",
      fr_FR: "/politiques-et-mentions-legales/[slug]",
      "it-IT": "/policies-and-disclaimer/[slug]",
      it_IT: "/policies-and-disclaimer/[slug]",
      "ja-JP": "/policies-and-disclaimer/[slug]",
      ja_JP: "/policies-and-disclaimer/[slug]",
      "es-MX": "/policies-and-disclaimer/[slug]",
      es_MX: "/policies-and-disclaimer/[slug]",
      "nl-NL": "/policies-and-disclaimer/[slug]",
      nl_NL: "/policies-and-disclaimer/[slug]",
      "no-NO": "/policies-and-disclaimer/[slug]",
      no_NO: "/policies-and-disclaimer/[slug]",
      "pl-PL": "/policies-and-disclaimer/[slug]",
      pl_PL: "/policies-and-disclaimer/[slug]",
      "pt-PT": "/policies-and-disclaimer/[slug]",
      pt_PT: "/policies-and-disclaimer/[slug]",
      "sv-SE": "/policies-and-disclaimer/[slug]",
      sv_SE: "/policies-and-disclaimer/[slug]",
      "en-AE": "/policies-and-disclaimer/[slug]",
      en_AE: "/policies-and-disclaimer/[slug]",
      "en-SG": "/policies-and-disclaimer/[slug]",
      en_SG: "/policies-and-disclaimer/[slug]",
      "en-GB": "/policies-and-disclaimer/[slug]",
      en_GB: "/policies-and-disclaimer/[slug]"
    },
    "policies-and-disclaimer/cookie-policy": {
      en: "/policies-and-disclaimer/cookie-policy",
      "en-AU": "/policies-and-disclaimer/cookie-policy",
      en_AU: "/policies-and-disclaimer/cookie-policy",
      "pt-BR": "/politicas-e-termo-de-responsabilidade/cookie-policy",
      pt_BR: "/politicas-e-termo-de-responsabilidade/cookie-policy",
      "zh-CN": "/policies-and-disclaimer/cookie-policy",
      zh_CN: "/policies-and-disclaimer/cookie-policy",
      "cs-CZ": "/policies-and-disclaimer/cookie-policy",
      cs_CZ: "/policies-and-disclaimer/cookie-policy",
      "da-DK": "/policies-and-disclaimer/cookie-policy",
      da_DK: "/policies-and-disclaimer/cookie-policy",
      "de-DE": "/richtlinien-und-haftungsausschluss/cookie-policy",
      de_DE: "/richtlinien-und-haftungsausschluss/cookie-policy",
      "es-ES": "/policies-and-disclaimer/cookie-policy",
      es_ES: "/policies-and-disclaimer/cookie-policy",
      "fr-FR": "/politiques-et-mentions-legales/cookie-policy",
      fr_FR: "/politiques-et-mentions-legales/cookie-policy",
      "it-IT": "/policies-and-disclaimer/cookie-policy",
      it_IT: "/policies-and-disclaimer/cookie-policy",
      "ja-JP": "/policies-and-disclaimer/cookie-policy",
      ja_JP: "/policies-and-disclaimer/cookie-policy",
      "es-MX": "/policies-and-disclaimer/cookie-policy",
      es_MX: "/policies-and-disclaimer/cookie-policy",
      "nl-NL": "/policies-and-disclaimer/cookie-policy",
      nl_NL: "/policies-and-disclaimer/cookie-policy",
      "no-NO": "/policies-and-disclaimer/cookie-policy",
      no_NO: "/policies-and-disclaimer/cookie-policy",
      "pl-PL": "/policies-and-disclaimer/cookie-policy",
      pl_PL: "/policies-and-disclaimer/cookie-policy",
      "pt-PT": "/policies-and-disclaimer/cookie-policy",
      pt_PT: "/policies-and-disclaimer/cookie-policy",
      "sv-SE": "/policies-and-disclaimer/cookie-policy",
      sv_SE: "/policies-and-disclaimer/cookie-policy",
      "en-AE": "/policies-and-disclaimer/cookie-policy",
      en_AE: "/policies-and-disclaimer/cookie-policy",
      "en-SG": "/policies-and-disclaimer/cookie-policy",
      en_SG: "/policies-and-disclaimer/cookie-policy",
      "en-GB": "/policies-and-disclaimer/cookie-policy",
      en_GB: "/policies-and-disclaimer/cookie-policy"
    },
    "policies-and-disclaimer/index": {
      en: "/policies-and-disclaimer",
      "en-AU": "/policies-and-disclaimer",
      en_AU: "/policies-and-disclaimer",
      "pt-BR": "/politicas-e-termo-de-responsabilidade",
      pt_BR: "/politicas-e-termo-de-responsabilidade",
      "zh-CN": "/policies-and-disclaimer",
      zh_CN: "/policies-and-disclaimer",
      "cs-CZ": "/policies-and-disclaimer",
      cs_CZ: "/policies-and-disclaimer",
      "da-DK": "/policies-and-disclaimer",
      da_DK: "/policies-and-disclaimer",
      "de-DE": "/richtlinien-und-haftungsausschluss",
      de_DE: "/richtlinien-und-haftungsausschluss",
      "es-ES": "/policies-and-disclaimer",
      es_ES: "/policies-and-disclaimer",
      "fr-FR": "/politiques-et-mentions-legales",
      fr_FR: "/politiques-et-mentions-legales",
      "it-IT": "/policies-and-disclaimer",
      it_IT: "/policies-and-disclaimer",
      "ja-JP": "/policies-and-disclaimer",
      ja_JP: "/policies-and-disclaimer",
      "es-MX": "/policies-and-disclaimer",
      es_MX: "/policies-and-disclaimer",
      "nl-NL": "/policies-and-disclaimer",
      nl_NL: "/policies-and-disclaimer",
      "no-NO": "/policies-and-disclaimer",
      no_NO: "/policies-and-disclaimer",
      "pl-PL": "/policies-and-disclaimer",
      pl_PL: "/policies-and-disclaimer",
      "pt-PT": "/policies-and-disclaimer",
      pt_PT: "/policies-and-disclaimer",
      "sv-SE": "/policies-and-disclaimer",
      sv_SE: "/policies-and-disclaimer",
      "en-AE": "/policies-and-disclaimer",
      en_AE: "/policies-and-disclaimer",
      "en-SG": "/policies-and-disclaimer",
      en_SG: "/policies-and-disclaimer",
      "en-GB": "/policies-and-disclaimer",
      en_GB: "/policies-and-disclaimer"
    },
    "policies-and-disclaimer/privacy-form": {
      en: "/policies-and-disclaimer/privacy-form",
      "en-AU": "/policies-and-disclaimer/privacy-form",
      en_AU: "/policies-and-disclaimer/privacy-form",
      "pt-BR": "/politicas-e-termo-de-responsabilidade/privacy-form",
      pt_BR: "/politicas-e-termo-de-responsabilidade/privacy-form",
      "zh-CN": "/policies-and-disclaimer/privacy-form",
      zh_CN: "/policies-and-disclaimer/privacy-form",
      "cs-CZ": "/policies-and-disclaimer/privacy-form",
      cs_CZ: "/policies-and-disclaimer/privacy-form",
      "da-DK": "/policies-and-disclaimer/privacy-form",
      da_DK: "/policies-and-disclaimer/privacy-form",
      "de-DE": "/richtlinien-und-haftungsausschluss/privacy-form",
      de_DE: "/richtlinien-und-haftungsausschluss/privacy-form",
      "es-ES": "/policies-and-disclaimer/privacy-form",
      es_ES: "/policies-and-disclaimer/privacy-form",
      "fr-FR": "/politiques-et-mentions-legales/privacy-form",
      fr_FR: "/politiques-et-mentions-legales/privacy-form",
      "it-IT": "/policies-and-disclaimer/privacy-form",
      it_IT: "/policies-and-disclaimer/privacy-form",
      "ja-JP": "/policies-and-disclaimer/privacy-form",
      ja_JP: "/policies-and-disclaimer/privacy-form",
      "es-MX": "/policies-and-disclaimer/privacy-form",
      es_MX: "/policies-and-disclaimer/privacy-form",
      "nl-NL": "/policies-and-disclaimer/privacy-form",
      nl_NL: "/policies-and-disclaimer/privacy-form",
      "no-NO": "/policies-and-disclaimer/privacy-form",
      no_NO: "/policies-and-disclaimer/privacy-form",
      "pl-PL": "/policies-and-disclaimer/privacy-form",
      pl_PL: "/policies-and-disclaimer/privacy-form",
      "pt-PT": "/policies-and-disclaimer/privacy-form",
      pt_PT: "/policies-and-disclaimer/privacy-form",
      "sv-SE": "/policies-and-disclaimer/privacy-form",
      sv_SE: "/policies-and-disclaimer/privacy-form",
      "en-AE": "/policies-and-disclaimer/privacy-form",
      en_AE: "/policies-and-disclaimer/privacy-form",
      "en-SG": "/policies-and-disclaimer/privacy-form",
      en_SG: "/policies-and-disclaimer/privacy-form",
      "en-GB": "/policies-and-disclaimer/privacy-form",
      en_GB: "/policies-and-disclaimer/privacy-form"
    },
    "pos-payments/dynamic-currency-conversion/index": {
      en: "/pos-payments/dynamic-currency-conversion",
      "en-AU": "/pos-payments/dynamic-currency-conversion",
      en_AU: "/pos-payments/dynamic-currency-conversion",
      "pt-BR": "/terminais-pagamento/conversao-dinamica-moedas",
      pt_BR: "/terminais-pagamento/conversao-dinamica-moedas",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/pos-betalinger/dynamisk-valutakonvertering",
      da_DK: "/pos-betalinger/dynamisk-valutakonvertering",
      "de-DE": "/pos-zahlungen/dynamische-wahrungsumrechnung",
      de_DE: "/pos-zahlungen/dynamische-wahrungsumrechnung",
      "es-ES": "/pagos-tpv/dynamic-currency-conversion",
      es_ES: "/pagos-tpv/dynamic-currency-conversion",
      "fr-FR": "/paiements-en-point-de-vente/conversion-dynamique-des-devises",
      fr_FR: "/paiements-en-point-de-vente/conversion-dynamique-des-devises",
      "it-IT": "/pagamenti-pos/dynamic-currency-conversion",
      it_IT: "/pagamenti-pos/dynamic-currency-conversion",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/pos-payments/dynamic-currency-conversion",
      es_MX: "/pos-payments/dynamic-currency-conversion",
      "nl-NL": "/pos-betalingen/dynamic-currency-conversion",
      nl_NL: "/pos-betalingen/dynamic-currency-conversion",
      "no-NO": "/pos-betalinger/dynamisk-valutaveksling",
      no_NO: "/pos-betalinger/dynamisk-valutaveksling",
      "pl-PL": "/platnosci-pos/dynamisk-valutaveksling",
      pl_PL: "/platnosci-pos/dynamisk-valutaveksling",
      "pt-PT": "/terminais-pagamento/conversao-dinamica-moedas",
      pt_PT: "/terminais-pagamento/conversao-dinamica-moedas",
      "sv-SE": "/fysiska-betalningar/dynamisk-valutavaxling",
      sv_SE: "/fysiska-betalningar/dynamisk-valutavaxling",
      "en-AE": "/pos-payments/dynamic-currency-conversion",
      en_AE: "/pos-payments/dynamic-currency-conversion",
      "en-SG": "/pos-payments/dynamic-currency-conversion",
      en_SG: "/pos-payments/dynamic-currency-conversion",
      "en-GB": "/pos-payments/dynamic-currency-conversion",
      en_GB: "/pos-payments/dynamic-currency-conversion"
    },
    "pos-payments/index": {
      en: "/pos-payments",
      "en-AU": "/pos-payments",
      en_AU: "/pos-payments",
      "pt-BR": "/terminais-pagamento",
      pt_BR: "/terminais-pagamento",
      "zh-CN": "/pos",
      zh_CN: "/pos",
      "cs-CZ": "/platby-pos-platebnl-terminaly",
      cs_CZ: "/platby-pos-platebnl-terminaly",
      "da-DK": "/pos-betalinger",
      da_DK: "/pos-betalinger",
      "de-DE": "/pos-zahlungen",
      de_DE: "/pos-zahlungen",
      "es-ES": "/pagos-tpv",
      es_ES: "/pagos-tpv",
      "fr-FR": "/paiements-en-point-de-vente",
      fr_FR: "/paiements-en-point-de-vente",
      "it-IT": "/pagamenti-pos",
      it_IT: "/pagamenti-pos",
      "ja-JP": "/pos-payments",
      ja_JP: "/pos-payments",
      "es-MX": "/pos-payments",
      es_MX: "/pos-payments",
      "nl-NL": "/pos-betalingen",
      nl_NL: "/pos-betalingen",
      "no-NO": "/pos-betalinger",
      no_NO: "/pos-betalinger",
      "pl-PL": "/platnosci-pos",
      pl_PL: "/platnosci-pos",
      "pt-PT": "/terminais-pagamento",
      pt_PT: "/terminais-pagamento",
      "sv-SE": "/fysiska-betalningar",
      sv_SE: "/fysiska-betalningar",
      "en-AE": "/pos-payments",
      en_AE: "/pos-payments",
      "en-SG": "/pos-payments",
      en_SG: "/pos-payments",
      "en-GB": "/pos-payments",
      en_GB: "/pos-payments"
    },
    "privacy-policy/[slug]": {
      en: "/privacy-policy/[slug]",
      "en-AU": "/privacy-policy/[slug]",
      en_AU: "/privacy-policy/[slug]",
      "pt-BR": "/privacy-policy/[slug]",
      pt_BR: "/privacy-policy/[slug]",
      "zh-CN": "/privacy-policy/[slug]",
      zh_CN: "/privacy-policy/[slug]",
      "cs-CZ": "/privacy-policy/[slug]",
      cs_CZ: "/privacy-policy/[slug]",
      "da-DK": "/privacy-policy/[slug]",
      da_DK: "/privacy-policy/[slug]",
      "de-DE": "/privacy-policy/[slug]",
      de_DE: "/privacy-policy/[slug]",
      "es-ES": "/privacy-policy/[slug]",
      es_ES: "/privacy-policy/[slug]",
      "fr-FR": "/privacy-policy/[slug]",
      fr_FR: "/privacy-policy/[slug]",
      "it-IT": "/privacy-policy/[slug]",
      it_IT: "/privacy-policy/[slug]",
      "ja-JP": "/privacy-policy/[slug]",
      ja_JP: "/privacy-policy/[slug]",
      "es-MX": "/privacy-policy/[slug]",
      es_MX: "/privacy-policy/[slug]",
      "nl-NL": "/privacy-policy/[slug]",
      nl_NL: "/privacy-policy/[slug]",
      "no-NO": "/privacy-policy/[slug]",
      no_NO: "/privacy-policy/[slug]",
      "pl-PL": "/privacy-policy/[slug]",
      pl_PL: "/privacy-policy/[slug]",
      "pt-PT": "/privacy-policy/[slug]",
      pt_PT: "/privacy-policy/[slug]",
      "sv-SE": "/privacy-policy/[slug]",
      sv_SE: "/privacy-policy/[slug]",
      "en-AE": "/privacy-policy/[slug]",
      en_AE: "/privacy-policy/[slug]",
      "en-SG": "/privacy-policy/[slug]",
      en_SG: "/privacy-policy/[slug]",
      "en-GB": "/privacy-policy/[slug]",
      en_GB: "/privacy-policy/[slug]"
    },
    "privacy-policy/index": {
      en: "/privacy-policy",
      "en-AU": "/privacy-policy",
      en_AU: "/privacy-policy",
      "pt-BR": "/privacy-policy",
      pt_BR: "/privacy-policy",
      "zh-CN": "/privacy-policy",
      zh_CN: "/privacy-policy",
      "cs-CZ": "/privacy-policy",
      cs_CZ: "/privacy-policy",
      "da-DK": "/privacy-policy",
      da_DK: "/privacy-policy",
      "de-DE": "/privacy-policy",
      de_DE: "/privacy-policy",
      "es-ES": "/privacy-policy",
      es_ES: "/privacy-policy",
      "fr-FR": "/privacy-policy",
      fr_FR: "/privacy-policy",
      "it-IT": "/privacy-policy",
      it_IT: "/privacy-policy",
      "ja-JP": "/privacy-policy",
      ja_JP: "/privacy-policy",
      "es-MX": "/privacy-policy",
      es_MX: "/privacy-policy",
      "nl-NL": "/privacy-policy",
      nl_NL: "/privacy-policy",
      "no-NO": "/privacy-policy",
      no_NO: "/privacy-policy",
      "pl-PL": "/privacy-policy",
      pl_PL: "/privacy-policy",
      "pt-PT": "/privacy-policy",
      pt_PT: "/privacy-policy",
      "sv-SE": "/privacy-policy",
      sv_SE: "/privacy-policy",
      "en-AE": "/privacy-policy",
      en_AE: "/privacy-policy",
      "en-SG": "/privacy-policy",
      en_SG: "/privacy-policy",
      "en-GB": "/privacy-policy",
      en_GB: "/privacy-policy"
    },
    "sdr/[slug]": {
      en: "/sdr/[slug]",
      "en-AU": false,
      en_AU: false,
      "pt-BR": "/sdr/[slug]",
      pt_BR: "/sdr/[slug]",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": "/sdr/[slug]",
      de_DE: "/sdr/[slug]",
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": "/sdr/[slug]",
      sv_SE: "/sdr/[slug]",
      "en-AE": "/sdr/[slug]",
      en_AE: "/sdr/[slug]",
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "sdr/index": {
      en: "/sdr",
      "en-AU": false,
      en_AU: false,
      "pt-BR": "/sdr",
      pt_BR: "/sdr",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": "/sdr",
      de_DE: "/sdr",
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": "/sdr",
      sv_SE: "/sdr",
      "en-AE": "/sdr",
      en_AE: "/sdr",
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    signup: {
      en: "/signup",
      "en-AU": "/signup",
      en_AU: "/signup",
      "pt-BR": "/signup",
      pt_BR: "/signup",
      "zh-CN": "/signup",
      zh_CN: "/signup",
      "cs-CZ": "/signup",
      cs_CZ: "/signup",
      "da-DK": "/signup",
      da_DK: "/signup",
      "de-DE": "/signup",
      de_DE: "/signup",
      "es-ES": "/signup",
      es_ES: "/signup",
      "fr-FR": "/signup",
      fr_FR: "/signup",
      "it-IT": "/signup",
      it_IT: "/signup",
      "ja-JP": "/signup",
      ja_JP: "/signup",
      "es-MX": "/signup",
      es_MX: "/signup",
      "nl-NL": "/signup",
      nl_NL: "/signup",
      "no-NO": "/signup",
      no_NO: "/signup",
      "pl-PL": "/signup",
      pl_PL: "/signup",
      "pt-PT": "/signup",
      pt_PT: "/signup",
      "sv-SE": "/signup",
      sv_SE: "/signup",
      "en-AE": "/signup",
      en_AE: "/signup",
      "en-SG": "/signup",
      en_SG: "/signup",
      "en-GB": "/signup",
      en_GB: "/signup"
    },
    "the-latest/[slug]": {
      en: "/the-latest/[slug]",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "the-latest/index": {
      en: "/the-latest",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "the-latest/the-spotlight/index": {
      en: "/the-latest/the-spotlight",
      "en-AU": false,
      en_AU: false,
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": false,
      en_GB: false
    },
    "uk-pricing-calculator": {
      en: "/uk-pricing-calculator",
      "en-AU": "/uk-pricing-calculator",
      en_AU: "/uk-pricing-calculator",
      "pt-BR": "/uk-pricing-calculator",
      pt_BR: "/uk-pricing-calculator",
      "zh-CN": "/uk-pricing-calculator",
      zh_CN: "/uk-pricing-calculator",
      "cs-CZ": "/uk-pricing-calculator",
      cs_CZ: "/uk-pricing-calculator",
      "da-DK": "/uk-pricing-calculator",
      da_DK: "/uk-pricing-calculator",
      "de-DE": "/uk-pricing-calculator",
      de_DE: "/uk-pricing-calculator",
      "es-ES": "/uk-pricing-calculator",
      es_ES: "/uk-pricing-calculator",
      "fr-FR": "/uk-pricing-calculator",
      fr_FR: "/uk-pricing-calculator",
      "it-IT": "/uk-pricing-calculator",
      it_IT: "/uk-pricing-calculator",
      "ja-JP": "/uk-pricing-calculator",
      ja_JP: "/uk-pricing-calculator",
      "es-MX": "/uk-pricing-calculator",
      es_MX: "/uk-pricing-calculator",
      "nl-NL": "/uk-pricing-calculator",
      nl_NL: "/uk-pricing-calculator",
      "no-NO": "/uk-pricing-calculator",
      no_NO: "/uk-pricing-calculator",
      "pl-PL": "/uk-pricing-calculator",
      pl_PL: "/uk-pricing-calculator",
      "pt-PT": "/uk-pricing-calculator",
      pt_PT: "/uk-pricing-calculator",
      "sv-SE": "/uk-pricing-calculator",
      sv_SE: "/uk-pricing-calculator",
      "en-AE": "/uk-pricing-calculator",
      en_AE: "/uk-pricing-calculator",
      "en-SG": "/uk-pricing-calculator",
      en_SG: "/uk-pricing-calculator",
      "en-GB": "/uk-pricing-calculator",
      en_GB: "/uk-pricing-calculator"
    },
    "unified-commerce/index": {
      en: "/unified-commerce",
      "en-AU": "/unified-commerce",
      en_AU: "/unified-commerce",
      "pt-BR": "/unified-commerce",
      pt_BR: "/unified-commerce",
      "zh-CN": "/unified-commerce",
      zh_CN: "/unified-commerce",
      "cs-CZ": "/unified-commerce",
      cs_CZ: "/unified-commerce",
      "da-DK": "/unified-commerce",
      da_DK: "/unified-commerce",
      "de-DE": "/unified-commerce",
      de_DE: "/unified-commerce",
      "es-ES": "/comercio-unificado",
      es_ES: "/comercio-unificado",
      "fr-FR": "/commerce-unifie",
      fr_FR: "/commerce-unifie",
      "it-IT": "/unified-commerce",
      it_IT: "/unified-commerce",
      "ja-JP": "/unified-commerce",
      ja_JP: "/unified-commerce",
      "es-MX": "/unified-commerce",
      es_MX: "/unified-commerce",
      "nl-NL": "/unified-commerce",
      nl_NL: "/unified-commerce",
      "no-NO": "/unified-commerce",
      no_NO: "/unified-commerce",
      "pl-PL": "/platnosci-omnichannel",
      pl_PL: "/platnosci-omnichannel",
      "pt-PT": "/unified-commerce",
      pt_PT: "/unified-commerce",
      "sv-SE": "/omnikanal",
      sv_SE: "/omnikanal",
      "en-AE": "/unified-commerce",
      en_AE: "/unified-commerce",
      "en-SG": "/unified-commerce",
      en_SG: "/unified-commerce",
      "en-GB": "/unified-commerce",
      en_GB: "/unified-commerce"
    },
    "uplift/[slug]": {
      en: "/uplift/[slug]",
      "en-AU": "/uplift/[slug]",
      en_AU: "/uplift/[slug]",
      "pt-BR": "/uplift/[slug]",
      pt_BR: "/uplift/[slug]",
      "zh-CN": "/uplift/[slug]",
      zh_CN: "/uplift/[slug]",
      "cs-CZ": "/uplift/[slug]",
      cs_CZ: "/uplift/[slug]",
      "da-DK": "/uplift/[slug]",
      da_DK: "/uplift/[slug]",
      "de-DE": "/uplift/[slug]",
      de_DE: "/uplift/[slug]",
      "es-ES": "/uplift/[slug]",
      es_ES: "/uplift/[slug]",
      "fr-FR": "/uplift/[slug]",
      fr_FR: "/uplift/[slug]",
      "it-IT": "/uplift/[slug]",
      it_IT: "/uplift/[slug]",
      "ja-JP": "/uplift/[slug]",
      ja_JP: "/uplift/[slug]",
      "es-MX": "/uplift/[slug]",
      es_MX: "/uplift/[slug]",
      "nl-NL": "/uplift/[slug]",
      nl_NL: "/uplift/[slug]",
      "no-NO": "/uplift/[slug]",
      no_NO: "/uplift/[slug]",
      "pl-PL": "/uplift/[slug]",
      pl_PL: "/uplift/[slug]",
      "pt-PT": "/uplift/[slug]",
      pt_PT: "/uplift/[slug]",
      "sv-SE": "/uplift/[slug]",
      sv_SE: "/uplift/[slug]",
      "en-AE": "/uplift/[slug]",
      en_AE: "/uplift/[slug]",
      "en-SG": "/uplift/[slug]",
      en_SG: "/uplift/[slug]",
      "en-GB": "/uplift/[slug]",
      en_GB: "/uplift/[slug]"
    },
    "uplift/index": {
      en: "/uplift",
      "en-AU": "/uplift",
      en_AU: "/uplift",
      "pt-BR": "/uplift",
      pt_BR: "/uplift",
      "zh-CN": "/uplift",
      zh_CN: "/uplift",
      "cs-CZ": "/uplift",
      cs_CZ: "/uplift",
      "da-DK": "/uplift",
      da_DK: "/uplift",
      "de-DE": "/uplift",
      de_DE: "/uplift",
      "es-ES": "/uplift",
      es_ES: "/uplift",
      "fr-FR": "/uplift",
      fr_FR: "/uplift",
      "it-IT": "/uplift",
      it_IT: "/uplift",
      "ja-JP": "/uplift",
      ja_JP: "/uplift",
      "es-MX": "/uplift",
      es_MX: "/uplift",
      "nl-NL": "/uplift",
      nl_NL: "/uplift",
      "no-NO": "/uplift",
      no_NO: "/uplift",
      "pl-PL": "/uplift",
      pl_PL: "/uplift",
      "pt-PT": "/uplift",
      pt_PT: "/uplift",
      "sv-SE": "/uplift",
      sv_SE: "/uplift",
      "en-AE": "/uplift",
      en_AE: "/uplift",
      "en-SG": "/uplift",
      en_SG: "/uplift",
      "en-GB": "/uplift",
      en_GB: "/uplift"
    },
    "web-payments/index": {
      en: "/web-payments",
      "en-AU": "/web-payments",
      en_AU: "/web-payments",
      "pt-BR": "/pagamentos-navegador",
      pt_BR: "/pagamentos-navegador",
      "zh-CN": "/web-payments",
      zh_CN: "/web-payments",
      "cs-CZ": "/webove-platby",
      cs_CZ: "/webove-platby",
      "da-DK": "/netbetalinger",
      da_DK: "/netbetalinger",
      "de-DE": "/ecommerce-zahlungen",
      de_DE: "/ecommerce-zahlungen",
      "es-ES": "/pagos-web",
      es_ES: "/pagos-web",
      "fr-FR": "/paiements-web",
      fr_FR: "/paiements-web",
      "it-IT": "/web-payments",
      it_IT: "/web-payments",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": "/pagos-web",
      es_MX: "/pagos-web",
      "nl-NL": "/web-betalingen",
      nl_NL: "/web-betalingen",
      "no-NO": "/web-nettbetalinger",
      no_NO: "/web-nettbetalinger",
      "pl-PL": "/platnosci-internetowe-checkout",
      pl_PL: "/platnosci-internetowe-checkout",
      "pt-PT": "/pagamentos-navegador",
      pt_PT: "/pagamentos-navegador",
      "sv-SE": "/webbetalningar",
      sv_SE: "/webbetalningar",
      "en-AE": "/web-payments",
      en_AE: "/web-payments",
      "en-SG": "/web-payments",
      en_SG: "/web-payments",
      "en-GB": "/web-payments",
      en_GB: "/web-payments"
    },
    "why-do-i-see-adyen-on-my-bank-statement/index": {
      en: "/why-do-i-see-adyen-on-my-bank-statement",
      "en-AU": false,
      en_AU: false,
      "pt-BR": "/o-que-e-adyen-boleto-dda",
      pt_BR: "/o-que-e-adyen-boleto-dda",
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/hvorfor-star-der-adyen-pa-mit-kontoudtog",
      da_DK: "/hvorfor-star-der-adyen-pa-mit-kontoudtog",
      "de-DE": "/warum-erscheint-adyen-auf-meinem-kontoauszug",
      de_DE: "/warum-erscheint-adyen-auf-meinem-kontoauszug",
      "es-ES": "/adyen-en-mi-estado-de-cuenta",
      es_ES: "/adyen-en-mi-estado-de-cuenta",
      "fr-FR": "/pourquoi-adyen-apparait-sur-mon-releve-bancaire",
      fr_FR: "/pourquoi-adyen-apparait-sur-mon-releve-bancaire",
      "it-IT": "/perche-vedo-adyen-sul-mio-estratto-conto-bancario",
      it_IT: "/perche-vedo-adyen-sul-mio-estratto-conto-bancario",
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": "/waarom-zie-ik-adyen-op-mijn-bankafschrift",
      nl_NL: "/waarom-zie-ik-adyen-op-mijn-bankafschrift",
      "no-NO": "/hvorfor-ser-jeg-adyen-pa-kontoutskriften",
      no_NO: "/hvorfor-ser-jeg-adyen-pa-kontoutskriften",
      "pl-PL": "/dlaczego-adyen-pojawia-sie-na-moim-wyciagu-bankowym",
      pl_PL: "/dlaczego-adyen-pojawia-sie-na-moim-wyciagu-bankowym",
      "pt-PT": "/o-que-e-adyen-boleto-dda",
      pt_PT: "/o-que-e-adyen-boleto-dda",
      "sv-SE": "/adyen-pa-mitt-kontoutdrag",
      sv_SE: "/adyen-pa-mitt-kontoutdrag",
      "en-AE": false,
      en_AE: false,
      "en-SG": false,
      en_SG: false,
      "en-GB": "/why-do-i-see-adyen-on-my-bank-statement",
      en_GB: "/why-do-i-see-adyen-on-my-bank-statement"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "Global",
    language: "en",
    _hreflang: "en",
    _sitemap: "en",
    files: []
  },
  {
    code: "en_AU",
    name: "Australia",
    language: "en-AU",
    _hreflang: "en-AU",
    _sitemap: "en-AU",
    files: []
  },
  {
    code: "pt_BR",
    name: "Brasil",
    language: "pt-BR",
    _hreflang: "pt-BR",
    _sitemap: "pt-BR",
    files: []
  },
  {
    code: "zh_CN",
    name: "中国",
    language: "zh-CN",
    _hreflang: "zh-CN",
    _sitemap: "zh-CN",
    files: []
  },
  {
    code: "cs_CZ",
    name: "Česká republika",
    language: "cs-CZ",
    _hreflang: "cs-CZ",
    _sitemap: "cs-CZ",
    files: []
  },
  {
    code: "da_DK",
    name: "Danmark",
    language: "da-DK",
    _hreflang: "da-DK",
    _sitemap: "da-DK",
    files: []
  },
  {
    code: "de_DE",
    name: "Deutschland",
    language: "de-DE",
    _hreflang: "de-DE",
    _sitemap: "de-DE",
    files: []
  },
  {
    code: "es_ES",
    name: "España",
    language: "es-ES",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: []
  },
  {
    code: "fr_FR",
    name: "France",
    language: "fr-FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR",
    files: []
  },
  {
    code: "it_IT",
    name: "Italia",
    language: "it-IT",
    _hreflang: "it-IT",
    _sitemap: "it-IT",
    files: []
  },
  {
    code: "ja_JP",
    name: "日本",
    language: "ja-JP",
    _hreflang: "ja-JP",
    _sitemap: "ja-JP",
    files: []
  },
  {
    code: "es_MX",
    name: "México",
    language: "es-MX",
    _hreflang: "es-MX",
    _sitemap: "es-MX",
    files: []
  },
  {
    code: "nl_NL",
    name: "Nederland",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: []
  },
  {
    code: "no_NO",
    name: "Norge",
    language: "no-NO",
    _hreflang: "no-NO",
    _sitemap: "no-NO",
    files: []
  },
  {
    code: "pl_PL",
    name: "Polska",
    language: "pl-PL",
    _hreflang: "pl-PL",
    _sitemap: "pl-PL",
    files: []
  },
  {
    code: "pt_PT",
    name: "Portugal",
    language: "pt-PT",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT",
    files: []
  },
  {
    code: "sv_SE",
    name: "Sverige",
    language: "sv-SE",
    _hreflang: "sv-SE",
    _sitemap: "sv-SE",
    files: []
  },
  {
    code: "en_AE",
    name: "United Arab Emirates",
    language: "en-AE",
    _hreflang: "en-AE",
    _sitemap: "en-AE",
    files: []
  },
  {
    code: "en_SG",
    name: "Singapore",
    language: "en-SG",
    _hreflang: "en-SG",
    _sitemap: "en-SG",
    files: []
  },
  {
    code: "en_GB",
    name: "United Kingdom",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/